export const newIcon = (
  <svg
    width="43"
    height="45"
    viewBox="0 0 56 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M28 51.344c14.498 0 26.25-11.123 26.25-24.844C54.25 12.78 42.498 1.656 28 1.656S1.75 12.78 1.75 26.5 13.502 51.344 28 51.344Z"
        stroke="#27187E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="28" cy="40.302" rx="1.75" ry="1.656" fill="#758BFD" />
      <path
        d="M28 30.652c-.117-1.833 1.073-3.534 2.917-4.152 3.92-1.413 5.88-5.565 4.363-9.275-1.493-3.71-5.88-5.565-9.8-4.13a7.686 7.686 0 0 0-3.337 2.363"
        stroke="#758BFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h56v53H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const pvIcon = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.75 53.624H2.25l6.277-23.271h40.18l6.043 23.271Z"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.17 42h45.57"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m21.873 29.799-3.126 23.825"
      stroke="#758BFD"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="m35.36 29.799 3.127 23.825"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M28.687 1.73v4.52M45.37 19.835h4.527M13.987 7.357l3.196 3.183m23.007 0 3.197-3.183M7.453 19.835h4.527"
      stroke="#758BFD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.413 24.771c0-6.758 5.484-12.247 12.25-12.247 6.767 0 12.25 5.49 12.25 12.247"
      stroke="#758BFD"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const deprivationIcon = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.366 26.391a12.321 12.321 0 1 0-.025 0h.025ZM2.25 54.25V43.388a7.263 7.263 0 0 1 7.241-7.241h21.724a7.263 7.263 0 0 1 7.242 7.241V54.25"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.82 26.034c1.066.37 2.184.565 3.313.58h.021a10.621 10.621 0 0 0 0-21.243 10.43 10.43 0 0 0-1.247.126M54.75 50.63v-9.365a6.26 6.26 0 0 0-6.242-6.242h-5.57"
      stroke="#758BFD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const energyEfficiencyIcon = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.247 8.447C.303 17.71-1.097 34.09 8.167 45.033c9.24 10.967 25.62 12.344 36.586 3.08 10.967-9.24 12.344-25.62 3.08-36.586a25.595 25.595 0 0 0-3.08-3.08M28 1.75v26.81"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const evIcon = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48.51 18.337-4.496 3.898m-7.158 8.989c1.84-.02 3.63.6 5.061 1.756a5.547 5.547 0 0 1 2.096 4.238v8.99a4.16 4.16 0 0 0 1.573 3.18 6.131 6.131 0 0 0 7.592 0 4.16 4.16 0 0 0 1.572-3.18V25.232L44.013 12.725"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m19.906 26.502-4.496 7.492h8.991l-4.495 7.493"
      stroke="#758BFD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 54.25h35.963M5.749 14.42h28.965M5.749 54.231V8.99a7.261 7.261 0 0 1 7.241-7.24h14.483a7.261 7.261 0 0 1 7.241 7.239V54.23"
      stroke="#27187E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const connectionIcon = (
  <svg
    width="55"
    height="55"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_34_774)">
      <path
        d="M12.9663 1.99137L22.0087 11.0338C22.1167 11.1403 22.2026 11.2671 22.2616 11.4068C22.3206 11.5465 22.3515 11.6965 22.3525 11.8481C22.3536 11.9998 22.3247 12.1501 22.2676 12.2907C22.2105 12.4312 22.1263 12.559 22.0198 12.667L19.9922 14.6946C19.3594 15.3252 18.5875 15.7984 17.7385 16.0762C16.8896 16.354 15.9872 16.4287 15.1041 16.2942C14.217 16.1507 13.3087 16.216 12.4513 16.4849C11.5939 16.7538 10.8109 17.2188 10.1646 17.8431L8.94805 19.0597C8.84009 19.1662 8.7122 19.2504 8.5717 19.3075C8.43119 19.3646 8.28082 19.3934 8.12916 19.3924C7.97751 19.3914 7.82754 19.3605 7.68782 19.3015C7.5481 19.2425 7.42137 19.1566 7.31487 19.0486L4.95149 16.6852C4.84352 16.5787 4.75759 16.452 4.6986 16.3123C4.63961 16.1725 4.60872 16.0226 4.60769 15.8709C4.60667 15.7193 4.63552 15.5689 4.69261 15.4284C4.7497 15.2879 4.83391 15.16 4.94043 15.052L6.15698 13.8355C6.78126 13.1892 7.2463 12.4062 7.51517 11.5488C7.78404 10.6914 7.84934 9.78305 7.7059 8.89598C7.57152 8.01289 7.64623 7.11059 7.92404 6.26164C8.20186 5.41268 8.67501 4.64076 9.30545 4.00796L11.3331 1.98032C11.5512 1.76529 11.8457 1.64566 12.152 1.64773C12.4582 1.6498 12.7511 1.7734 12.9663 1.99137V1.99137Z"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.8159 3.84103L17.9069 0.75"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.1589 9.18422L23.25 6.0932"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.4873 6.51261L21.4949 2.505"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.1479 12.524C13.8837 12.7881 13.5471 12.9678 13.1807 13.0406C12.8143 13.1134 12.4345 13.0759 12.0894 12.9329C11.7443 12.7899 11.4494 12.5478 11.2419 12.2372C11.0343 11.9266 10.9236 11.5614 10.9236 11.1878C10.9236 10.8143 11.0343 10.4491 11.2419 10.1385C11.4494 9.82787 11.7443 9.58574 12.0894 9.44274C12.4345 9.29973 12.8143 9.26225 13.1807 9.33504C13.5471 9.40783 13.8837 9.58762 14.1479 9.85169C14.5023 10.2061 14.7014 10.6867 14.7014 11.1878C14.7014 11.689 14.5023 12.1696 14.1479 12.524V12.524Z"
        stroke="#758BFD"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.85633 18.1437L0.75 23.25"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_34_774">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const heatpumpIcon = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M41.113 1.75H14.887a4.75 4.75 0 0 0-4.76 4.76v38.127a4.75 4.75 0 0 0 4.76 4.76H41.09a4.75 4.75 0 0 0 4.76-4.76V6.51a4.75 4.75 0 0 0-4.76-4.76h.023Z"
        stroke="#27187E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.577 49.583v4.667"
        stroke="#758BFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.423 49.583v4.667"
        stroke="#27187E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.724 24.267c.303-1.96-.724-3.827-1.33-4.434 0 1.82-1.074 2.847-1.82 3.594-.747.746-1.214 1.936-1.214 3.01 0 1.983 1.634 3.593 3.64 3.593 2.007 0 3.64-1.61 3.64-3.593 0-.91-.63-2.357-1.213-3.01-.35.536-1.307 1.12-1.703.84Z"
        stroke="#758BFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path stroke="#27187E" strokeWidth="1.5" d="M9.333 12.223h37.334" />
      <path
        stroke="#27187E"
        strokeWidth="1.5"
        strokeLinecap="round"
        d="M19.417 40.224h17.166"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h56v56H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const flexibilityIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_34_1502)">
      <path
        d="M7.77181 14.4983L21.7312 23.9699C21.7762 23.9699 16.176 14.4983 16.176 14.4983L2.26843 23.9699C2.26843 23.9699 7.85037 14.4983 7.77181 14.4983Z"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.78845 7.2738L16.1927 14.5004C16.235 14.5004 16.1927 7.2738 16.1927 7.2738L7.78845 14.5004C7.78845 14.5004 7.86235 7.2738 7.78845 7.2738Z"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.81299 7.22197L12.025 1.46997L16.236 7.22197"
        stroke="#27187E"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 9.76894V7.05994H4.997"
        stroke="#758BFD"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2501 9.76894V7.05994H19.0031"
        stroke="#758BFD"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_34_1502">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.719971)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const fundingSourceIcon = (
  <svg
    width="65"
    height="65"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5255 11.2008L13.5219 11.2047C13.3616 10.6135 13.5175 10.0003 14.0501 9.58183C15.4232 8.50343 16.9602 10.1832 17.8433 9.04565C18.3225 10.2239 17.6188 11.4426 16.8606 12.0382C16.1021 12.6338 14.4859 12.6869 13.8911 11.9274C13.8788 11.9117 13.8672 11.8957 13.8554 11.8798C13.9222 11.8066 13.9869 11.7337 14.049 11.6627"
      stroke="#758BFD"
      strokeWidth={0.5}
    />
    <path
      d="M10.2662 11.5247L10.2692 11.5291C10.5094 10.966 10.4398 10.3371 9.96991 9.84909C8.75891 8.59104 7.00485 10.0419 6.28711 8.79297C5.64998 9.89365 6.17872 11.1982 6.84777 11.8931C7.51654 12.5877 9.11021 12.8639 9.80374 12.1941C9.81832 12.1803 9.83208 12.166 9.84584 12.152C9.78944 12.0703 9.73579 11.9888 9.6838 11.9102"
      stroke="#758BFD"
      strokeWidth={0.5}
    />
    <mask
      id="mask0_383_93"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={7}
      y={15}
      width={10}
      height={9}
    >
      <path d="M7.69177 15.7163H16.1429V23.456H7.69177V15.7163Z" fill="white" />
    </mask>
    <g mask="url(#mask0_383_93)">
      <path
        d="M11.5896 16.9154H11.3396V17.1654V17.6862C10.8321 17.8626 10.467 18.3455 10.467 18.9131C10.467 19.41 10.7472 19.8427 11.158 20.0609H10.717H10.467V20.3109C10.467 20.8785 10.8321 21.3614 11.3396 21.5378V22.0586V22.3086H11.5896H12.2876H12.5376V22.0586V21.5378C13.0448 21.3613 13.4099 20.8784 13.4099 20.3109C13.4099 19.814 13.1298 19.3813 12.7191 19.1631H13.1599H13.4099V18.9131C13.4099 18.3456 13.0448 17.8627 12.5376 17.6862V17.1654V16.9154H12.2876H11.5896ZM11.6649 20.3109V20.2078C11.6977 20.2102 11.7307 20.2115 11.764 20.2115H12.1129C12.1671 20.2115 12.212 20.2561 12.212 20.3109C12.212 20.3661 12.167 20.4105 12.1129 20.4105H11.764C11.7101 20.4105 11.6649 20.3659 11.6649 20.3109ZM12.212 18.9131V19.0162C12.1793 19.0137 12.1462 19.0125 12.1129 19.0125H11.764C11.7099 19.0125 11.6649 18.9677 11.6649 18.9131C11.6649 18.8581 11.7101 18.8134 11.764 18.8134H12.1129C12.167 18.8134 12.212 18.8579 12.212 18.9131ZM11.9385 23.2064C11.0857 23.2064 10.0675 23.0777 9.27142 22.8049C8.87257 22.6683 8.54581 22.501 8.32315 22.3088C8.10377 22.1195 8.00085 21.9212 8.00085 21.709C8.00085 21.0953 8.00288 19.6543 8.50699 18.371C8.75767 17.7329 9.1277 17.147 9.6717 16.7207C10.2124 16.297 10.9419 16.0176 11.9385 16.0176C12.9351 16.0176 13.6647 16.297 14.2054 16.7207C14.7494 17.147 15.1195 17.7329 15.3702 18.371C15.8743 19.6543 15.8763 21.0953 15.8763 21.709C15.8763 21.9212 15.7734 22.1195 15.554 22.3088C15.3314 22.501 15.0046 22.6683 14.6057 22.8049C13.8096 23.0777 12.7914 23.2064 11.9385 23.2064Z"
        stroke="#758BFD"
        strokeWidth={0.5}
      />
    </g>
    <mask
      id="mask1_383_93"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={8}
      y={1}
      width={8}
      height={15}
    >
      <path d="M8.396 1.80005H15.4386V15.7868H8.396V1.80005Z" fill="white" />
    </mask>
    <g mask="url(#mask1_383_93)">
      <path
        d="M11.8706 12.348L11.8751 12.0862C11.8882 11.314 11.9774 10.4826 12.0567 9.74556L11.8706 12.348ZM11.8706 12.348L12.1323 12.3403C12.7148 12.3233 13.1107 12.0126 13.4355 11.6734C13.466 11.7344 13.4996 11.7946 13.536 11.8538C13.173 12.2231 12.7508 12.5274 12.1327 12.5403L11.8726 12.5458L11.8884 12.8055C11.9181 13.2909 11.9957 13.7483 12.1581 14.1203L12.2236 14.2703H12.3872H13.0694C12.9716 15.0644 12.4153 15.5177 11.9385 15.5177C11.4617 15.5177 10.9054 15.0644 10.8077 14.2703H11.6436H11.9859L11.8818 13.9442C11.8158 13.7375 11.7673 13.5108 11.7339 13.2669L11.708 13.0778L11.5187 13.053C10.8735 12.9685 10.4835 12.5987 10.1658 12.1703C10.21 12.1167 10.2515 12.0618 10.2902 12.0056C10.5453 12.3591 10.8651 12.6976 11.3691 12.822L11.6893 12.901L11.6789 12.5714C11.6507 11.6789 11.7572 10.6802 11.8597 9.72409C11.8938 9.40906 11.927 9.09929 11.9539 8.80509L11.9773 8.54986L11.7215 8.53287C10.0338 8.42078 8.69885 7.01506 8.69885 5.29595C8.69885 3.50326 10.1496 2.05078 11.9385 2.05078C13.7274 2.05078 15.1782 3.50326 15.1782 5.29595C15.1782 6.9401 13.957 8.2977 12.3742 8.5109L12.176 8.5376L12.1585 8.73682C12.1312 9.04875 12.096 9.3777 12.0595 9.71866L12.0567 9.74541L11.8706 12.348ZM12.0135 7.88499L12.1253 7.66099L13.146 4.98081C13.037 4.804 12.8443 4.6963 12.6365 4.6963H12.2096L12.8233 3.46676L12.9348 3.24335L12.7115 3.13156L12.0873 2.81904L11.8635 2.70701L11.7517 2.93091L10.7047 5.02774L10.7045 5.02807C10.6122 5.21372 10.622 5.43414 10.7309 5.61084L10.7311 5.6111C10.8401 5.78761 11.0327 5.89533 11.2406 5.89533H11.6677L11.0538 7.12485L10.9423 7.34819L11.1655 7.46003L11.7897 7.77283L12.0135 7.88499ZM11.2406 5.64533C11.1195 5.64533 11.0073 5.58261 10.9438 5.47972L11.7925 5.64533H11.2406Z"
        stroke="#27187E"
        strokeWidth={0.5}
      />
    </g>
  </svg>
);

export const lowCarbonIcon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_456_453"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="-1"
      y="0"
      width="26"
      height="22"
    >
      <path
        d="M-0.00012207 0.440002H24.0233V21.5338H-0.00012207V0.440002Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_456_453)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0387 10.4962C21.4369 9.89587 20.6178 9.58185 19.7691 9.6142C19.4371 9.64258 19.1545 9.36823 19.1737 9.03467C19.2051 8.52014 19.1804 8.00989 19.1029 7.51123C19.4996 7.41663 19.8402 7.24634 20.1378 7.026C20.233 7.51337 20.2852 8.01599 20.2891 8.53021C21.2736 8.62177 22.158 9.05878 22.8187 9.71796C23.596 10.4934 24.0269 11.535 24.0269 12.629C24.0269 13.7655 23.5652 14.7949 22.8187 15.5395C22.0723 16.2844 21.0405 16.7452 19.9012 16.7452H17.8825L18.7318 15.6448H19.9012C20.7356 15.6448 21.4918 15.3069 22.0387 14.761C22.5856 14.2156 22.924 13.4612 22.924 12.629C22.924 11.8273 22.6079 11.0641 22.0387 10.4962ZM18.7797 17.272V19.2883H19.4774C19.6116 19.2883 19.7126 19.3679 19.7569 19.4729C19.8002 19.5745 19.7902 19.6996 19.7041 19.7952L18.4614 21.4059C18.3995 21.4865 18.3076 21.5249 18.217 21.5234C18.1263 21.5228 18.0369 21.4816 17.9774 21.4022L16.7238 19.7778C16.6493 19.6801 16.6435 19.5681 16.6841 19.4753C16.7311 19.3691 16.84 19.2883 16.9767 19.2883H17.6762V17.272H18.7797ZM16.0255 14.5098H14.9223V16.5264H14.2222C14.0855 16.5264 13.9772 16.607 13.9299 16.7132C13.8893 16.806 13.8951 16.9186 13.9695 17.0156L15.2232 18.6401C15.283 18.7197 15.3721 18.7606 15.4628 18.7615C15.5531 18.7631 15.645 18.7243 15.7069 18.644L16.9499 17.0336C17.036 16.9378 17.0457 16.8127 17.0027 16.7108C16.9584 16.6064 16.8571 16.5267 16.7231 16.5267H16.0255V14.5098ZM18.7193 6.83893C19.5454 6.72662 20.066 6.1944 20.4796 5.58771C20.9089 4.95721 21.2233 4.24585 21.6438 3.84119C21.7585 3.73102 21.8126 3.63916 21.7854 3.57599C21.7625 3.52258 21.6807 3.48871 21.5281 3.48077C19.5469 3.37671 17.6957 3.71423 17.4064 5.85962C17.3662 6.15778 17.4159 6.3244 17.5032 6.35828C17.5926 6.39307 17.7333 6.28961 17.9008 6.05157C18.4419 5.28223 18.8731 4.76709 19.6544 4.33984C19.7679 4.27759 19.8527 4.26752 19.8799 4.29559C19.9074 4.32458 19.8747 4.39386 19.7508 4.48969C19.2811 4.85406 18.6039 5.69543 18.2991 6.2594C18.1572 6.52216 18.1352 6.6842 18.2106 6.77179C18.2872 6.8606 18.4645 6.87341 18.7193 6.83893ZM14.9296 8.24762C13.6531 8.07397 12.848 7.25183 12.209 6.31372C11.5452 5.3396 11.0594 4.24005 10.41 3.61505C10.2324 3.44476 10.1484 3.30255 10.1906 3.20459C10.2263 3.12219 10.3526 3.07001 10.5882 3.0578C13.6506 2.89728 16.5117 3.41852 16.9587 6.73456C17.021 7.19537 16.9441 7.45233 16.8089 7.50482C16.6707 7.55884 16.4537 7.39893 16.1946 7.03119C15.3578 5.84192 14.6916 5.04602 13.484 4.38531C13.3088 4.28949 13.1776 4.27362 13.1358 4.31696C13.0934 4.36182 13.1437 4.46863 13.3348 4.61725C14.0611 5.1806 15.1079 6.48035 15.5787 7.35193C15.7982 7.75812 15.8323 8.00867 15.7161 8.14386C15.5974 8.28119 15.3236 8.30103 14.9296 8.24762ZM7.62769 14.0029C6.90137 14.0029 6.18268 13.7637 5.65228 13.2577C5.13379 12.7636 4.87286 12.088 4.87286 11.3772C4.87286 10.5352 5.22443 9.84247 5.78626 9.38043C6.27423 8.97943 6.9212 8.75208 7.63501 8.75208C8.32013 8.75208 8.99152 8.94891 9.50391 9.41522C9.63147 9.5321 9.66229 9.71246 9.52466 9.83881L9.17218 10.1632C9.06964 10.2609 8.90546 10.2651 8.79834 10.1699C8.48523 9.89099 8.11383 9.75275 7.6933 9.75275C7.23218 9.75275 6.83759 9.909 6.55194 10.1769C6.24524 10.4653 6.06488 10.8834 6.06488 11.3772C6.06488 11.806 6.20007 12.2164 6.50159 12.528C6.81622 12.8536 7.2453 13.002 7.6933 13.002C8.11627 13.002 8.48523 12.8619 8.79743 12.5799C8.90149 12.4853 9.06323 12.4841 9.16882 12.5811L9.51917 12.9037C9.63941 13.0126 9.65009 13.196 9.52924 13.3111C9.01227 13.8012 8.33295 14.0029 7.62769 14.0029ZM18.2042 12.7618C18.5267 12.4832 18.8102 12.2024 18.8102 11.7571C18.8102 11.4147 18.65 11.1727 18.4166 11.0122C18.1495 10.8291 17.7861 10.7516 17.4537 10.7516C17.0048 10.7516 16.5333 10.8688 16.2098 11.1956C16.0798 11.3259 16.114 11.5426 16.273 11.6296L16.5339 11.7861C16.6484 11.8542 16.7747 11.8304 16.8705 11.7443C17.0103 11.6158 17.202 11.5661 17.3881 11.5661C17.5303 11.5661 17.7879 11.5969 17.8166 11.7767C17.8358 11.9109 17.7574 12.0107 17.6698 12.1041C17.2877 12.5152 16.7241 12.9357 16.302 13.3007C16.241 13.3535 16.2059 13.4338 16.2059 13.5125V13.7277C16.2059 13.8854 16.3325 14.0026 16.4891 14.0026H18.6506C18.809 14.0026 18.9265 13.8763 18.9265 13.72V13.4854C18.9265 13.3276 18.7999 13.2104 18.6436 13.2104H17.6902L18.2042 12.7618ZM12.8752 14.0029C12.1437 14.0029 11.4195 13.7637 10.8827 13.2571C10.3599 12.7645 10.0914 12.0913 10.0914 11.3772C10.0914 10.6634 10.3599 9.99017 10.8827 9.49762C11.4192 8.99103 12.144 8.75208 12.8752 8.75208C13.6073 8.75208 14.3315 8.99164 14.8689 9.49823C15.3917 9.99139 15.659 10.6634 15.659 11.3772C15.659 12.0913 15.3914 12.7636 14.8686 13.2568C14.3318 13.7631 13.6067 14.0029 12.8752 14.0029ZM12.8752 13.002C13.3018 13.002 13.704 12.8576 14.0083 12.5543C14.3254 12.2381 14.467 11.8197 14.467 11.3772C14.467 10.9445 14.3309 10.5319 14.0257 10.2178C13.7208 9.9032 13.3101 9.75275 12.8752 9.75275C12.4482 9.75275 12.0466 9.89709 11.7421 10.2004C11.4253 10.5166 11.2837 10.9353 11.2837 11.3772C11.2837 11.7834 11.4033 12.1728 11.6737 12.4813C11.9807 12.832 12.4144 13.002 12.8752 13.002ZM5.81738 15.8926C5.70264 15.7052 5.49878 15.614 5.28455 15.6317C4.12549 15.7244 2.99664 15.306 2.18427 14.4637C1.51624 13.7713 1.10547 12.8295 1.10547 11.7913C1.10547 10.7845 1.49182 9.8681 2.12354 9.18298C2.76135 8.49146 3.64941 8.03278 4.64368 7.9516C4.91711 7.93054 5.1286 7.71326 5.14996 7.44867C5.42462 5.77081 6.2959 4.2901 7.5398 3.23083C8.77179 2.18134 10.3724 1.54749 12.1226 1.54749C14.1655 1.54749 16.0957 2.42242 17.4388 3.95502C17.6835 3.67395 17.9759 3.44934 18.3055 3.27173C16.7479 1.47485 14.5085 0.446716 12.1226 0.446716C10.1024 0.446716 8.25147 1.18097 6.82416 2.39679C5.47986 3.5412 4.51245 5.11591 4.13373 6.9082C3.02533 7.09558 2.04205 7.64917 1.31329 8.43927C0.499084 9.32184 0.00195312 10.4995 0.00195312 11.7913C0.00195312 13.175 0.572022 14.4274 1.4903 15.3265C2.44519 16.2609 3.72144 16.7684 5.05872 16.7434C6.24097 18.4677 8.18799 19.4973 10.2836 19.4973C11.5901 19.4973 12.8386 19.0972 13.8801 18.3782L13.2069 17.5057C12.357 18.0776 11.3435 18.3962 10.2839 18.3962C8.45624 18.3965 6.76862 17.4499 5.81738 15.8926Z"
        fill="black"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_NEWICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_706_68"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="-1"
      y="-1"
      width="26"
      height="26"
    >
      <path
        d="M-0.00012207 -0.00012207H24.0233V24.0233H-0.00012207V-0.00012207Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_706_68)">
      <path
        d="M12.0116 24.0233C5.38867 24.0233 -0.00012207 18.6348 -0.00012207 12.0116C-0.00012207 5.38867 5.38867 -0.00012207 12.0116 -0.00012207C18.6348 -0.00012207 24.0233 5.38867 24.0233 12.0116C24.0233 18.6348 18.6348 24.0233 12.0116 24.0233ZM12.0116 1.74182C6.34753 1.74182 1.7403 6.34753 1.7403 12.0116C1.7403 17.6744 6.34753 22.2817 12.0116 22.2817C17.6744 22.2817 22.2832 17.6744 22.2832 12.0116C22.2832 6.34753 17.6744 1.74182 12.0116 1.74182Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M12.2593 18.2451C12.1672 18.2097 12.0671 18.1526 12.0671 17.9109C12.0671 17.8111 12.0829 17.6955 12.1183 17.5545L13.6354 10.1995C13.6693 10.0267 13.6866 9.84576 13.6866 9.6657C13.6866 9.19054 13.5402 8.8286 13.2512 8.58904C12.6033 8.05681 11.4695 8.16119 9.58386 8.7987L9.40076 8.86004L9.32568 9.80913H9.64246C10.6025 9.80913 10.8345 9.88421 10.8827 9.9074C10.9471 9.93822 10.9825 9.97484 10.9825 10.0832C10.9825 10.143 10.9749 10.2107 10.959 10.2858C10.9404 10.3856 10.9178 10.5013 10.8961 10.6258L9.50574 17.3809C9.44104 17.7211 9.40747 18.0132 9.40747 18.2457C9.40747 18.784 9.56281 19.2 9.86615 19.4808C10.1634 19.7548 10.5711 19.8943 11.0771 19.8943C11.6694 19.8943 12.4644 19.7301 13.5063 19.3929L13.6924 19.3328L13.7675 18.3711H13.4532C12.7406 18.3711 12.4119 18.3022 12.2593 18.2451Z"
      fill="#758BFD"
    />
    <path
      d="M14.2565 4.5412C13.9706 4.26868 13.6025 4.12891 13.164 4.12891C12.7099 4.12891 12.3257 4.27844 12.0229 4.57202C11.7184 4.86713 11.5627 5.26416 11.5627 5.75366C11.5627 6.2041 11.7108 6.57794 12.0013 6.86755C12.2918 7.15961 12.6641 7.30762 13.1057 7.30762C13.5562 7.30762 13.9367 7.15076 14.2407 6.84436C14.5425 6.53827 14.6948 6.14032 14.6948 5.66119C14.6948 5.19366 14.5486 4.81677 14.2565 4.5412Z"
      fill="#758BFD"
    />
  </svg>
);

export const LAEP_SSEN_PVICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.17456 17.1248L5.93286 19.7365H14.0435L13.8021 17.1248H6.17456Z"
      fill="#758BFD"
    />
    <path
      d="M18.4159 13.4084H14.2051L14.4797 16.3799H18.8004L18.4159 13.4084Z"
      fill="#758BFD"
    />
    <path
      d="M18.0298 10.425H13.9292L14.1361 12.6635H18.3195L18.0298 10.425Z"
      fill="#758BFD"
    />
    <mask
      id="mask0_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="14"
      y="17"
      width="6"
      height="3"
    >
      <path
        d="M14.5312 17.0781H19.2169V19.8125H14.5312V17.0781Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_706_76)">
      <path
        d="M14.5483 17.1248L14.79 19.7365H18.9178C19.086 19.7365 19.2157 19.5882 19.194 19.4213L18.8968 17.1248H14.5483Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M13.4586 13.4084H6.51794L6.24329 16.3799H13.7332L13.4586 13.4084Z"
      fill="#758BFD"
    />
    <mask
      id="mask1_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="20"
      width="6"
      height="5"
    >
      <path
        d="M7.73438 20.4375H12.2656V24.0233H7.73438V20.4375Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_706_76)">
      <path
        d="M7.75842 20.4814H12.218V24.0233H7.75842V20.4814Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M9.98834 4.47559C7.85944 4.47559 6.10529 6.11469 5.91699 8.19995H14.0594C13.8711 6.11469 12.1169 4.47559 9.98834 4.47559Z"
      fill="#758BFD"
    />
    <mask
      id="mask2_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="17"
      width="6"
      height="3"
    >
      <path
        d="M0.759888 17.0781H5.46875V19.8125H0.759888V17.0781Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_706_76)">
      <path
        d="M1.05901 19.7365H5.18651L5.42821 17.1248H1.07976L0.782516 19.421C0.760849 19.5882 0.890853 19.7365 1.05901 19.7365Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M13.1827 10.425H6.79382L6.58691 12.6635H13.3896L13.1827 10.425Z"
      fill="#758BFD"
    />
    <path
      d="M1.94702 10.425L1.6571 12.6635H5.84045L6.04736 10.425H1.94702Z"
      fill="#758BFD"
    />
    <path
      d="M1.17615 16.3799H5.49683L5.77179 13.4084H1.56067L1.17615 16.3799Z"
      fill="#758BFD"
    />
    <mask
      id="mask3_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="23"
      width="6"
      height="2"
    >
      <path d="M12.9688 23.25H17.8125V24.0233H12.9688V23.25Z" fill="white" />
    </mask>
    <g mask="url(#mask3_706_76)">
      <path
        d="M13.0459 24.0233H17.4206C17.626 24.0233 17.7923 23.8567 17.7923 23.651C17.7923 23.4453 17.626 23.2784 17.4206 23.2784H13.0459C13.0459 23.2784 13.0459 23.6089 13.0459 24.0233Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask4_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="23"
      width="5"
      height="2"
    >
      <path d="M2.10938 23.25H6.95313V24.0233H2.10938V23.25Z" fill="white" />
    </mask>
    <g mask="url(#mask4_706_76)">
      <path
        d="M6.93396 24.0233H2.55896C2.35358 24.0233 2.18726 23.8567 2.18726 23.651C2.18726 23.4453 2.35358 23.2784 2.55896 23.2784H6.93396C6.93396 23.2784 6.93396 23.6089 6.93396 24.0233Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M15.9344 8.38031H18.1641C18.3691 8.38031 18.5358 8.21338 18.5358 8.00769C18.5358 7.802 18.3691 7.63538 18.1641 7.63538H15.9344C15.7291 7.63538 15.5627 7.802 15.5627 8.00769C15.5627 8.21338 15.7291 8.38031 15.9344 8.38031Z"
      fill="#758BFD"
    />
    <path
      d="M1.44067 8.00769C1.44067 8.21338 1.6073 8.38031 1.81238 8.38031H4.0423C4.24738 8.38031 4.4137 8.21338 4.4137 8.00769C4.4137 7.802 4.24738 7.63538 4.0423 7.63538H1.81238C1.6073 7.63538 1.44067 7.802 1.44067 8.00769Z"
      fill="#758BFD"
    />
    <path
      d="M5.8075 4.74872C5.90271 4.74872 5.99762 4.7124 6.07025 4.63977C6.21552 4.4942 6.21552 4.25861 6.07025 4.11304L4.39789 2.43701C4.25293 2.29144 4.01764 2.29144 3.87238 2.43701C3.72711 2.58228 3.72711 2.81818 3.87238 2.96375L5.54474 4.63977C5.61737 4.7124 5.71228 4.74872 5.8075 4.74872Z"
      fill="#758BFD"
    />
    <path
      d="M16.1041 2.43701C15.9591 2.29144 15.7238 2.29144 15.5786 2.43701L13.9062 4.11304C13.7612 4.25861 13.7612 4.4942 13.9062 4.63977C13.9788 4.7124 14.0741 4.74872 14.169 4.74872C14.2642 4.74872 14.3591 4.7124 14.4317 4.63977L16.1041 2.96375C16.2493 2.81818 16.2493 2.58228 16.1041 2.43701Z"
      fill="#758BFD"
    />
    <mask
      id="mask5_706_76"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="9"
      y="-1"
      width="2"
      height="5"
    >
      <path
        d="M9.60938 -0.00012207H10.3906V3.01562H9.60938V-0.00012207Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_706_76)">
      <path
        d="M9.6167 0.372498V2.6073C9.6167 2.81299 9.78302 2.97961 9.9884 2.97961C10.1935 2.97961 10.3598 2.81299 10.3598 2.6073V0.372498C10.3598 0.166809 10.1935 -0.00012207 9.9884 -0.00012207C9.78302 -0.00012207 9.6167 0.166809 9.6167 0.372498Z"
        fill="#758BFD"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_DEPRIVATIONICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.1295 7.6235C5.1295 7.54417 5.15283 7.4765 5.1995 7.4205C5.2485 7.36217 5.322 7.333 5.42 7.333H5.7945V6.507C5.7945 6.28767 5.82717 6.08 5.8925 5.884C5.96017 5.68567 6.0605 5.513 6.1935 5.366C6.3265 5.21667 6.49333 5.09883 6.694 5.0125C6.89467 4.92617 7.13033 4.883 7.401 4.883C7.58533 4.883 7.751 4.9075 7.898 4.9565C8.04733 5.00317 8.17917 5.06733 8.2935 5.149C8.41017 5.23067 8.5105 5.3275 8.5945 5.4395C8.68083 5.54917 8.7555 5.66817 8.8185 5.7965L8.472 6.017C8.39033 6.059 8.31217 6.07767 8.2375 6.073C8.16517 6.06833 8.09867 6.031 8.038 5.961C7.99367 5.90967 7.94933 5.863 7.905 5.821C7.863 5.77667 7.8175 5.73933 7.7685 5.709C7.7195 5.67633 7.66467 5.65183 7.604 5.6355C7.54567 5.61917 7.478 5.611 7.401 5.611C7.16067 5.611 6.981 5.69033 6.862 5.849C6.743 6.00533 6.6835 6.2235 6.6835 6.5035V7.333H8.115V7.676C8.115 7.732 8.09167 7.78333 8.045 7.83C7.99833 7.87667 7.94 7.9 7.87 7.9H6.6835V8.579C6.6835 8.733 6.65433 8.87067 6.596 8.992C6.54 9.111 6.463 9.22183 6.365 9.3245C6.449 9.30583 6.533 9.29183 6.617 9.2825C6.701 9.27083 6.78733 9.265 6.876 9.265H8.927V9.629C8.927 9.671 8.91767 9.71417 8.899 9.7585C8.88267 9.80283 8.85817 9.84367 8.8255 9.881C8.79283 9.916 8.75317 9.94517 8.7065 9.9685C8.65983 9.9895 8.6085 10 8.5525 10H5.1995V9.4575C5.2765 9.43883 5.35117 9.41317 5.4235 9.3805C5.49583 9.3455 5.55883 9.30233 5.6125 9.251C5.6685 9.19733 5.71283 9.1355 5.7455 9.0655C5.77817 8.99317 5.7945 8.90917 5.7945 8.8135V7.9H5.1295V7.6235Z"
      fill="#758BFD"
    />
    <path
      d="M4 19C4 19.55 4.45 20 5 20H9C9.55 20 10 19.55 10 19V18H4V19ZM7 0C3.14 0 0 3.14 0 7C0 9.38 1.19 11.47 3 12.74V15C3 15.55 3.45 16 4 16H10C10.55 16 11 15.55 11 15V12.74C12.81 11.47 14 9.38 14 7C14 3.14 10.86 0 7 0ZM9.85 11.1L9 11.7V14H5V11.7L4.15 11.1C2.8 10.16 2 8.63 2 7C2 4.24 4.24 2 7 2C9.76 2 12 4.24 12 7C12 8.63 11.2 10.16 9.85 11.1Z"
      fill="#758BFD"
    />
  </svg>
);

export const LAEP_SSEN_ENERGYICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1493 4.45367C11.878 4.39019 11.6015 4.5202 11.4776 4.76739L7.89544 11.9225C7.80297 12.1075 7.81274 12.3269 7.92138 12.5027C8.03033 12.6785 8.22228 12.7856 8.4295 12.7856H11.4147V16.9595C11.4147 17.2363 11.6052 17.4764 11.8743 17.5396C11.9207 17.5503 11.9662 17.5558 12.0116 17.5558C12.2341 17.5558 12.4429 17.4313 12.5457 17.2262L16.1282 10.0707C16.2206 9.8858 16.2109 9.66638 16.1022 9.4906C15.9933 9.31512 15.8013 9.208 15.5941 9.208H12.6089V5.03381C12.6089 4.75732 12.4184 4.51715 12.1493 4.45367Z"
      fill="#758BFD"
    />
    <mask
      id="mask0_706_69"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="22"
      height="12"
    >
      <path
        d="M2.07812 0.859924H23.9531V11.625H2.07812V0.859924Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_706_69)">
      <path
        d="M23.778 8.78626C23.5448 8.55341 23.167 8.55341 22.9336 8.78626L22.072 9.64685C21.4092 4.69293 17.1502 0.859924 12.0116 0.859924C7.26858 0.859924 3.20394 4.07709 2.12728 8.68402C2.05251 9.00476 2.25179 9.3252 2.57314 9.39996C2.89297 9.47443 3.21554 9.27515 3.29 8.95502C4.23971 4.89099 7.82644 2.05255 12.0116 2.05255C16.95 2.05255 20.9676 6.0647 20.9676 10.9966C20.9676 11.2377 21.1132 11.4553 21.336 11.5475C21.4101 11.578 21.4876 11.593 21.5645 11.593C21.7199 11.593 21.8725 11.5325 21.9869 11.4184L23.778 9.62946C24.0111 9.39661 24.0111 9.0191 23.778 8.78626Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask1_706_69"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="10"
      width="22"
      height="12"
    >
      <path
        d="M0.046875 10.375H21.9219V21.1334H0.046875V10.375Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_706_69)">
      <path
        d="M21.4507 12.5933C21.1275 12.5179 20.808 12.7178 20.7335 13.0383C19.7832 17.1026 16.1968 19.9407 12.0116 19.9407C7.07355 19.9407 3.05591 15.9286 3.05591 10.9966C3.05591 10.7556 2.91034 10.538 2.68726 10.4458C2.46356 10.3536 2.20721 10.4043 2.03662 10.5752L0.245544 12.3638C0.0123901 12.597 0.0123901 12.9742 0.245544 13.207C0.478699 13.4402 0.856506 13.4402 1.08966 13.207L1.95117 12.3467C2.61401 17.3004 6.87335 21.1334 12.0116 21.1334C16.7546 21.1334 20.8193 17.9162 21.8959 13.3096C21.9713 12.9885 21.7717 12.6681 21.4507 12.5933Z"
        fill="#758BFD"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_EVICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_449_491"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <path d="M0 0.479919H24.0234V23.5073H0V0.479919Z" fill="white" />
    </mask>
    <g mask="url(#mask0_449_491)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8317 15.5703L9.59442 14.204L10.5621 10.5831C10.5701 10.5529 10.5731 10.5217 10.571 10.4903C10.5688 10.4592 10.5615 10.429 10.5493 10.4C10.5368 10.371 10.52 10.3447 10.499 10.3215C10.4779 10.298 10.4535 10.2788 10.4257 10.2635C10.3979 10.2486 10.3687 10.2382 10.3375 10.233C10.3067 10.2275 10.2756 10.2275 10.2444 10.2327C10.2133 10.2376 10.1837 10.2477 10.1559 10.2629C10.1285 10.2779 10.1038 10.2968 10.0827 10.32L6.12183 14.6257C6.10779 14.641 6.09558 14.6575 6.08521 14.6755C6.07483 14.6935 6.06659 14.7124 6.06018 14.7322C6.05408 14.7521 6.05011 14.7722 6.04858 14.793C6.04675 14.8134 6.04736 14.8342 6.05011 14.8546C6.05316 14.8754 6.05835 14.8952 6.06567 14.9147C6.073 14.934 6.08215 14.9526 6.09375 14.9697C6.10504 14.9871 6.11816 15.0029 6.13312 15.0176C6.14807 15.0319 6.16425 15.0444 6.18225 15.0554L8.41919 16.4217L7.45148 20.0429C7.44324 20.0734 7.44049 20.1042 7.44263 20.1357C7.44476 20.1671 7.45209 20.1973 7.4646 20.226C7.47711 20.255 7.4939 20.2812 7.51495 20.3044C7.53601 20.3279 7.56042 20.3469 7.5882 20.3621C7.61597 20.3774 7.64526 20.3875 7.67639 20.3926C7.70721 20.3981 7.73834 20.3981 7.76947 20.3929C7.8006 20.3878 7.8299 20.3777 7.85767 20.3627C7.88544 20.3478 7.90985 20.3286 7.93121 20.3054L11.8918 15.9999C11.9058 15.9847 11.918 15.9679 11.9284 15.9499C11.9388 15.9319 11.9473 15.9133 11.9534 15.8934C11.9595 15.8736 11.9635 15.8531 11.9653 15.8327C11.9669 15.812 11.9666 15.7912 11.9635 15.7708C11.9608 15.7503 11.9556 15.7302 11.9482 15.7106C11.9409 15.6914 11.9315 15.6731 11.9202 15.6557C11.9089 15.6383 11.8954 15.6224 11.8805 15.6081C11.8655 15.5934 11.8494 15.5809 11.8317 15.5703ZM2.10388 21.166V2.35461C2.10419 2.31189 2.10632 2.26916 2.1106 2.22644C2.11456 2.18372 2.12097 2.1413 2.12952 2.09918C2.13776 2.05707 2.14844 2.01556 2.16095 1.97467C2.17316 1.93347 2.18781 1.89319 2.20428 1.85352C2.22076 1.81415 2.23907 1.77539 2.25922 1.73755C2.27966 1.69971 2.30164 1.66278 2.32544 1.62738C2.34955 1.59167 2.37488 1.55719 2.40234 1.52393C2.4295 1.49097 2.45819 1.45923 2.48871 1.42871C2.51892 1.3985 2.55096 1.36981 2.58392 1.34265C2.61719 1.31519 2.65167 1.28986 2.68738 1.26605C2.72308 1.24225 2.76001 1.21997 2.79785 1.19983C2.83569 1.17969 2.87445 1.16138 2.91412 1.1449C2.9538 1.12842 2.99408 1.11407 3.03528 1.10156C3.07648 1.08905 3.11798 1.07867 3.1601 1.07013C3.20221 1.06189 3.24463 1.05548 3.28735 1.05121C3.33008 1.04694 3.37311 1.0448 3.41583 1.0448H14.5975C14.6405 1.0448 14.6832 1.04694 14.726 1.05121C14.7687 1.05548 14.8111 1.06189 14.8532 1.07013C14.8953 1.07867 14.9371 1.08905 14.978 1.10156C15.0192 1.11407 15.0595 1.12842 15.0992 1.1449C15.1389 1.16138 15.1779 1.17969 15.2158 1.19983C15.2536 1.21997 15.2902 1.24225 15.3259 1.26605C15.3616 1.28986 15.3961 1.31519 15.4294 1.34265C15.4626 1.36981 15.4944 1.3985 15.5249 1.42871C15.5551 1.45923 15.5841 1.49097 15.6113 1.52393C15.6384 1.55719 15.6641 1.59167 15.6879 1.62738C15.7117 1.66278 15.7339 1.69971 15.7541 1.73755C15.7745 1.77539 15.7928 1.81384 15.8093 1.85352C15.8258 1.89319 15.8401 1.93347 15.8527 1.97467C15.8652 2.01556 15.8755 2.05707 15.8841 2.09918C15.8923 2.1413 15.8987 2.18372 15.903 2.22644C15.9073 2.26916 15.9094 2.31189 15.9094 2.35461V21.166H2.10388ZM23.7415 4.81891C23.7787 4.81891 23.8147 4.82623 23.8492 4.84058C23.8837 4.85461 23.9139 4.87506 23.9404 4.90131C23.9667 4.92786 23.9871 4.95807 24.0012 4.99255C24.0155 5.02704 24.0225 5.06274 24.0225 5.09998V6.64935C24.0225 6.74457 24.0143 6.83856 23.9978 6.93225C23.981 7.02563 23.9566 7.11688 23.924 7.2063C23.8913 7.29541 23.8513 7.38116 23.8037 7.46326C23.7561 7.54565 23.7018 7.62317 23.6407 7.6958C23.5794 7.76843 23.5126 7.83527 23.4396 7.8963C23.3667 7.95734 23.2892 8.01166 23.2068 8.05896C23.1244 8.10657 23.0383 8.14624 22.9492 8.17889C22.8598 8.21124 22.7682 8.23566 22.6746 8.25214V16.2905C22.6749 16.3567 22.6718 16.4229 22.6657 16.4888C22.6596 16.5547 22.6501 16.6204 22.6373 16.6854C22.6248 16.7507 22.6089 16.8148 22.5897 16.8782C22.5708 16.942 22.5485 17.0043 22.5235 17.0656C22.4982 17.127 22.4701 17.1871 22.439 17.2457C22.4078 17.3043 22.374 17.361 22.3373 17.4163C22.3004 17.4715 22.261 17.5249 22.2192 17.5762C22.1771 17.6274 22.1329 17.6769 22.0859 17.7239C22.0392 17.7709 21.9901 17.8154 21.9388 17.8575C21.8875 17.8997 21.8344 17.9393 21.7792 17.9763C21.7239 18.0132 21.6672 18.0474 21.6086 18.0785C21.5503 18.1099 21.4902 18.1383 21.4288 18.1636C21.3675 18.1893 21.3052 18.2115 21.2418 18.2308C21.1783 18.2503 21.1139 18.2665 21.0486 18.2793C20.9836 18.2924 20.918 18.3022 20.8521 18.3086C20.7858 18.315 20.7196 18.3184 20.6531 18.3184C20.5869 18.3184 20.5206 18.315 20.4544 18.3086C20.3885 18.3022 20.3229 18.2924 20.2576 18.2793C20.1926 18.2665 20.1282 18.2503 20.0647 18.2308C20.0012 18.2115 19.9387 18.1893 19.8773 18.1636C19.816 18.1383 19.7562 18.1099 19.6976 18.0785C19.639 18.0474 19.5822 18.0132 19.5273 17.9763C19.472 17.9393 19.4186 17.8997 19.3677 17.8575C19.3164 17.8154 19.2673 17.7709 19.2203 17.7239C19.1736 17.6769 19.129 17.6274 19.0872 17.5762C19.0451 17.5249 19.0057 17.4715 18.9691 17.4163C18.9325 17.361 18.8983 17.3043 18.8672 17.2457C18.8364 17.1871 18.808 17.127 18.783 17.0656C18.7576 17.0043 18.7357 16.942 18.7164 16.8782C18.6975 16.8148 18.6816 16.7507 18.6691 16.6854C18.6563 16.6204 18.6469 16.5547 18.6407 16.4888C18.6343 16.4229 18.6316 16.3567 18.6319 16.2905V8.95831C18.6319 8.91376 18.6273 8.8692 18.6185 8.82556C18.6099 8.78162 18.5968 8.7392 18.5797 8.69769C18.5626 8.65649 18.5416 8.61743 18.5168 8.5802C18.4918 8.54297 18.4637 8.50848 18.432 8.47705C18.4003 8.44531 18.3658 8.41724 18.3286 8.39221C18.2913 8.36749 18.2523 8.34644 18.2108 8.32935C18.1696 8.31226 18.1268 8.29913 18.0829 8.29059C18.0389 8.28174 17.9947 8.27747 17.9501 8.27716H16.4728V21.166H17.7319C17.7692 21.166 17.8052 21.173 17.8397 21.1873C17.8741 21.2017 17.9047 21.2218 17.9309 21.2484C17.9575 21.2746 17.9779 21.3051 17.9919 21.3396C18.0063 21.3741 18.0136 21.4098 18.0136 21.447V23.228C18.0133 23.2653 18.0063 23.3013 17.9919 23.3358C17.9776 23.3699 17.9575 23.4005 17.9309 23.4267C17.9047 23.4532 17.8741 23.4734 17.8397 23.4877C17.8052 23.5021 17.7692 23.5091 17.7319 23.5091H0.281677C0.244446 23.5091 0.208435 23.5021 0.17395 23.4877C0.139465 23.4737 0.108948 23.4532 0.0827026 23.427C0.0561524 23.4005 0.0357056 23.3702 0.0216675 23.3358C0.00732428 23.3013 0 23.2653 0 23.228V21.447C0 21.4098 0.00732428 21.3741 0.0216675 21.3396C0.0357056 21.3051 0.0561524 21.2749 0.0827026 21.2484C0.108948 21.2221 0.139465 21.2017 0.17395 21.1876C0.208435 21.1733 0.244446 21.166 0.281677 21.166H1.54083V2.35461C1.54083 2.29327 1.54388 2.23224 1.54999 2.1712C1.55609 2.11017 1.56525 2.04974 1.57745 1.98962C1.58936 1.9295 1.60431 1.87 1.62231 1.8114C1.64001 1.75281 1.66077 1.69513 1.68427 1.63867C1.70776 1.58191 1.73401 1.52667 1.763 1.47266C1.79199 1.41864 1.82343 1.36615 1.8576 1.31519C1.89178 1.26422 1.92841 1.21509 1.96716 1.16779C2.00623 1.12018 2.04742 1.07501 2.09076 1.03168C2.13409 0.988342 2.17957 0.947144 2.22717 0.908386C2.27448 0.869324 2.32391 0.833008 2.37488 0.798828C2.42584 0.764648 2.47833 0.733215 2.53265 0.704224C2.58667 0.675537 2.64221 0.649292 2.69867 0.625793C2.75543 0.602295 2.81311 0.581543 2.87201 0.563843C2.9306 0.545837 2.99011 0.530884 3.05023 0.518982C3.11066 0.506775 3.17108 0.497925 3.23212 0.491821C3.29346 0.485718 3.35449 0.482666 3.41583 0.482666H14.5975C14.6588 0.482666 14.7202 0.485718 14.7812 0.491821C14.8422 0.497925 14.903 0.506775 14.9631 0.518982C15.0232 0.530884 15.0827 0.545837 15.1416 0.563843C15.2002 0.581543 15.2579 0.602295 15.3146 0.625793C15.3714 0.649292 15.4266 0.675537 15.481 0.704224C15.535 0.733215 15.5875 0.764648 15.6387 0.798828C15.6897 0.832703 15.7388 0.869324 15.7864 0.908081C15.8337 0.947144 15.8792 0.988342 15.9225 1.03168C15.9662 1.07501 16.0074 1.12018 16.0461 1.16779C16.0852 1.21509 16.1218 1.26422 16.1557 1.31519C16.1899 1.36615 16.2216 1.41864 16.2506 1.47266C16.2793 1.52667 16.3055 1.58191 16.3293 1.63867C16.3528 1.69513 16.3736 1.75281 16.3913 1.8114C16.4093 1.87 16.4243 1.9295 16.4362 1.98962C16.4484 2.04974 16.4572 2.11017 16.4633 2.1712C16.4694 2.23224 16.4725 2.29327 16.4728 2.35461V7.71472H17.9501C18.0316 7.71503 18.1125 7.72296 18.1927 7.73914C18.273 7.755 18.3508 7.77881 18.4262 7.80994C18.5016 7.84137 18.5733 7.87952 18.6414 7.92499C18.7091 7.97046 18.772 8.02173 18.83 8.07941C18.8876 8.13739 18.9392 8.19995 18.9847 8.26801C19.0302 8.33575 19.0683 8.40717 19.0997 8.48254C19.1312 8.55792 19.1547 8.63574 19.1708 8.7157C19.1867 8.79565 19.1949 8.87653 19.1949 8.95831V16.2902C19.1949 16.3378 19.1974 16.3854 19.202 16.433C19.2065 16.4803 19.2136 16.5276 19.223 16.5743C19.2322 16.6213 19.2438 16.6674 19.2578 16.7131C19.2715 16.7586 19.2877 16.8035 19.306 16.8477C19.3243 16.8917 19.3448 16.9347 19.3671 16.9768C19.3896 17.0189 19.4144 17.0598 19.4409 17.0995C19.4672 17.1392 19.4958 17.1773 19.5261 17.2142C19.5563 17.2512 19.5883 17.2863 19.6222 17.3201C19.6561 17.3537 19.6912 17.3857 19.7284 17.416C19.7653 17.4465 19.8035 17.4749 19.8431 17.5011C19.8828 17.5276 19.924 17.5521 19.9661 17.5746C20.0082 17.5972 20.0513 17.6177 20.0955 17.6357C20.1395 17.654 20.1843 17.6702 20.2301 17.6839C20.2759 17.6979 20.3223 17.7092 20.369 17.7187C20.416 17.7278 20.463 17.7349 20.5106 17.7397C20.5582 17.7443 20.6058 17.7468 20.6537 17.7468C20.7013 17.7468 20.7489 17.7443 20.7965 17.7397C20.8441 17.7349 20.8914 17.7278 20.9381 17.7187C20.9851 17.7092 21.0312 17.6979 21.077 17.6839C21.1227 17.6702 21.1676 17.654 21.2119 17.6357C21.2561 17.6177 21.2991 17.5972 21.3412 17.5746C21.3834 17.5521 21.4243 17.5276 21.4639 17.5011C21.5036 17.4749 21.5421 17.4465 21.579 17.416C21.6159 17.3857 21.6513 17.3537 21.6852 17.3201C21.7188 17.2863 21.7508 17.2512 21.7813 17.2142C21.8115 17.1773 21.8399 17.1392 21.8665 17.0995C21.893 17.0598 21.9174 17.0189 21.94 16.9768C21.9626 16.9347 21.983 16.8917 22.0013 16.8474C22.0197 16.8035 22.0355 16.7586 22.0496 16.7131C22.0633 16.6674 22.0749 16.6213 22.0844 16.5743C22.0935 16.5276 22.1005 16.4803 22.1054 16.433C22.11 16.3854 22.1124 16.3378 22.1124 16.2902V8.25214C22.0187 8.23566 21.9272 8.21124 21.8378 8.17889C21.7484 8.14655 21.6623 8.10657 21.5799 8.05896C21.4975 8.01166 21.42 7.95734 21.347 7.8963C21.2741 7.83527 21.2073 7.76843 21.1459 7.6958C21.0849 7.62317 21.0303 7.54565 20.9827 7.46356C20.9351 7.38116 20.8951 7.29541 20.8624 7.2063C20.8298 7.11719 20.8051 7.02563 20.7886 6.93225C20.7721 6.83856 20.7635 6.74457 20.7635 6.64935V5.09998C20.7635 5.06274 20.7706 5.02704 20.7849 4.99255C20.7993 4.95807 20.8197 4.92755 20.8459 4.90131C20.8725 4.87506 20.9027 4.85461 20.9372 4.84027C20.9717 4.82623 21.0077 4.81891 21.0449 4.81891H21.2775V3.73401C21.2772 3.69647 21.2839 3.66016 21.2979 3.62537C21.312 3.59058 21.3321 3.55975 21.3586 3.5332C21.3849 3.50635 21.4154 3.4859 21.4502 3.47125C21.485 3.45691 21.521 3.44958 21.5585 3.44958C21.5964 3.44958 21.6324 3.45691 21.6672 3.47125C21.7017 3.4859 21.7322 3.50635 21.7587 3.5332C21.785 3.55975 21.8054 3.59058 21.8195 3.62537C21.8335 3.66016 21.8402 3.69647 21.8399 3.73401V4.81891H22.9465V3.73401C22.9462 3.69647 22.9529 3.66016 22.9669 3.62537C22.981 3.59058 23.0011 3.55975 23.0276 3.5332C23.0539 3.50635 23.0847 3.4856 23.1192 3.47125C23.154 3.45691 23.19 3.44958 23.2278 3.44958C23.2654 3.44958 23.3014 3.45691 23.3362 3.47125C23.371 3.4856 23.4015 3.50635 23.4277 3.5332C23.4543 3.55975 23.4744 3.59058 23.4885 3.62537C23.5025 3.66016 23.5092 3.69647 23.5089 3.73401V4.81891H23.7415ZM14.3439 2.32715H3.66974C3.6322 2.32715 3.5965 2.33417 3.56201 2.34821C3.52753 2.36255 3.49701 2.383 3.47046 2.40924C3.44421 2.43579 3.42377 2.466 3.40942 2.50049C3.39539 2.53497 3.38806 2.57098 3.38806 2.60822V9.17865C3.38806 9.21588 3.39539 9.25159 3.40942 9.28607C3.42377 9.32056 3.44421 9.35107 3.47046 9.37732C3.49701 9.40387 3.52753 9.42401 3.56201 9.43835C3.5965 9.4527 3.6322 9.45972 3.66974 9.45972H14.3439C14.3811 9.45972 14.4171 9.45239 14.4516 9.43805C14.4861 9.42401 14.5166 9.40356 14.5428 9.37732C14.5694 9.35077 14.5895 9.32056 14.6039 9.28607C14.6182 9.25159 14.6252 9.21588 14.6252 9.17865V2.60822C14.6252 2.57098 14.6182 2.53497 14.6039 2.50049C14.5895 2.46631 14.5694 2.43579 14.5428 2.40955C14.5166 2.383 14.4861 2.36285 14.4516 2.34851C14.4171 2.33417 14.3811 2.32715 14.3439 2.32715Z"
        fill="#758BFD"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_HEATPUMP_ICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_706_77"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="20"
    >
      <path d="M0 0.625H24.0234V19.375H0V0.625Z" fill="white" />
    </mask>
    <g mask="url(#mask0_706_77)">
      <path
        d="M23.4515 17.8421C23.4515 17.999 23.3234 18.1271 23.1656 18.1271H18.8538C18.6966 18.1271 18.5684 17.999 18.5684 17.8421V1.88141C18.5684 1.72455 18.6966 1.59637 18.8538 1.59637H23.1656C23.3234 1.59637 23.4515 1.72455 23.4515 1.88141V17.8421ZM17.785 2.89734H17.0044V1.6217H17.4579C17.6376 1.6217 17.785 1.76758 17.785 1.94794V2.89734ZM17.785 4.13544H17.0044V3.07556H17.785V4.13544ZM17.785 5.37354H17.0044V4.31335H17.785V5.37354ZM17.785 6.61102H17.0044V5.55145H17.785V6.61102ZM17.785 7.84912H17.0044V6.78955H17.785V7.84912ZM17.785 9.08722H17.0044V8.02765H17.785V9.08722ZM17.785 10.3256H17.0044V9.26514H17.785V10.3256ZM17.785 11.5631H17.0044V10.5038H17.785V11.5631ZM17.785 12.8012H17.0044V11.7413H17.785V12.8012ZM17.785 14.0393H17.0044V12.9797H17.785V14.0393ZM17.785 15.2774H17.0044V14.2178H17.785V15.2774ZM17.785 16.5155H17.0044V15.4559H17.785V16.5155ZM17.785 17.7753C17.785 17.9556 17.6376 18.1015 17.4579 18.1015H17.0044V16.694H17.785V17.7753ZM16.8262 2.89734H16.0031V1.6217H16.8262V2.89734ZM16.8262 4.13544H16.0031V3.07556H16.8262V4.13544ZM16.8262 5.37354H16.0031V4.31335H16.8262V5.37354ZM16.8262 6.61102H16.1914C16.1334 6.4798 16.0699 6.34949 16.0031 6.22223V5.55145H16.8262V6.61102ZM16.8262 7.84912H16.6144C16.5265 7.48627 16.4114 7.13257 16.2686 6.78955H16.8262V7.84912ZM16.8262 9.08722H16.8008C16.778 8.72772 16.7288 8.37402 16.6541 8.02765H16.8262V9.08722ZM16.8262 10.3256H16.7752C16.8021 10.0717 16.8158 9.81415 16.8158 9.55597C16.8158 9.45862 16.814 9.36127 16.81 9.26514H16.8262V10.3256ZM16.8262 11.5631H16.5338C16.6339 11.218 16.7078 10.8643 16.7545 10.5038H16.8262V11.5631ZM16.8262 12.8012H16.0483C16.2204 12.4606 16.3651 12.1063 16.4807 11.7413H16.8262V12.8012ZM16.8262 14.0393H16.0031V12.9797H16.8262V14.0393ZM16.8262 15.2774H16.0031V14.2178H16.8262V15.2774ZM16.8262 16.5155H16.0031V15.4559H16.8262V16.5155ZM16.8262 18.1015H16.0031V16.694H16.8262V18.1015ZM15.8243 2.89734H15.0018V1.6217H15.8243V2.89734ZM15.8243 4.13544H15.0018V3.07556H15.8243V4.13544ZM15.8243 5.37354H15.4822C15.3336 5.16571 15.1733 4.96429 15.0018 4.77142V4.31335H15.8243V5.37354ZM15.8243 5.90118C15.755 5.78278 15.6818 5.66589 15.6052 5.55145H15.8243V5.90118ZM15.8243 14.0393H15.2545C15.4651 13.7753 15.6549 13.4979 15.8243 13.2104V14.0393ZM15.8243 15.2774H15.0018V14.3399C15.0378 14.2996 15.0732 14.259 15.1077 14.2178H15.8243V15.2774ZM15.8243 16.5155H15.0018V15.4559H15.8243V16.5155ZM15.8243 18.1015H15.0018V16.694H15.8243V18.1015ZM14.8233 10.7761C14.7382 10.766 14.6451 10.7178 14.5862 10.5792C14.5862 10.5792 14.5798 10.5511 14.5633 10.5038C14.5483 10.4596 14.5248 10.3979 14.4888 10.3256C14.4049 10.1505 14.2557 9.90784 13.9999 9.67102C13.9462 9.62067 13.8867 9.57031 13.822 9.52148L13.7976 9.50317C13.7976 9.50317 13.6368 9.37225 13.3411 9.26514C12.9803 9.13452 12.4176 9.04022 11.701 9.26514C11.6147 9.29199 11.5262 9.32404 11.4352 9.36127C11.4426 9.42535 11.4459 9.49005 11.4459 9.55597C11.4459 9.79218 11.4014 10.0177 11.3208 10.2255C11.4105 10.2484 11.5244 10.2811 11.6571 10.3256C11.792 10.3705 11.9458 10.4294 12.1112 10.5038C12.3318 10.6021 12.5739 10.7281 12.8207 10.8884C12.8796 10.9268 12.9391 10.9674 12.9987 11.0098C13.2166 11.1655 13.4344 11.3486 13.6432 11.5631C13.6981 11.6205 13.7524 11.6794 13.8062 11.7413C13.8113 11.748 13.8168 11.7538 13.822 11.7596C13.8821 11.8289 13.941 11.9022 13.9981 11.9781C13.9981 11.9781 13.9993 11.9794 13.9999 11.9821C14.0247 12.0212 14.2459 12.377 14.3533 12.8012C14.3683 12.8601 14.3808 12.9187 14.3906 12.9797C14.4324 13.2425 14.4186 13.5178 14.2825 13.7515C14.2825 13.7515 14.2322 13.8687 14.0921 14.0393C14.0247 14.1217 13.9359 14.2166 13.822 14.3164C13.6288 14.4864 13.3612 14.6713 12.9987 14.8376C12.9425 14.863 12.883 14.8886 12.8207 14.9133C12.655 14.9808 12.4719 15.0427 12.269 15.0977C12.1747 15.1233 12.0844 15.1462 11.9974 15.1663C11.936 15.1813 11.8771 15.1944 11.8188 15.2069C11.6754 15.2368 11.5427 15.2603 11.4197 15.2774C10.8966 15.3519 10.5579 15.322 10.3555 15.2774C10.1846 15.2408 10.1135 15.1938 10.1135 15.1938C10.1135 15.1938 9.87732 14.9643 10.0729 14.769C10.209 14.6329 10.4163 14.4583 10.5963 14.2178C10.6381 14.1623 10.6781 14.1028 10.7153 14.0393C10.7495 13.9819 10.7809 13.9215 10.8096 13.8577C10.8096 13.8577 10.813 13.8522 10.8176 13.8446C10.8484 13.7927 10.9589 13.5855 10.9955 13.2547C11.0052 13.1711 11.0098 13.0789 11.0074 12.9797C11.0007 12.7469 10.9543 12.4738 10.8353 12.1671C10.8295 12.1515 10.8234 12.1378 10.8176 12.1225C10.7593 11.9754 10.7037 11.8494 10.65 11.7413C10.618 11.6754 10.5865 11.6159 10.5563 11.5631C10.4761 11.4206 10.4041 11.3211 10.343 11.2518C10.2325 11.301 10.116 11.34 9.9942 11.3669C9.93622 11.3806 9.87732 11.391 9.81628 11.3983C9.74121 11.4075 9.66522 11.412 9.5874 11.412C9.54803 11.412 9.50867 11.4114 9.47021 11.4087C9.47327 11.4618 9.47601 11.5128 9.47784 11.5631C9.48059 11.6245 9.48181 11.684 9.48181 11.7413C9.48639 12.2369 9.42627 12.6044 9.38324 12.8012C9.36005 12.9083 9.34174 12.9654 9.34174 12.9654C9.34174 12.9654 9.34052 12.97 9.33868 12.9797C9.31976 13.0646 9.21295 13.5196 8.99323 14.0146C8.94012 14.1333 8.88123 14.2551 8.815 14.3735C8.8092 14.3839 8.80341 14.3942 8.7973 14.4055C8.5788 14.7885 8.24249 15.0336 7.99194 15.1743C7.92511 15.2121 7.86438 15.2423 7.81311 15.2649C7.80457 15.2695 7.7948 15.2734 7.78564 15.2774C7.70721 15.3122 7.65808 15.3284 7.65808 15.3284C7.65808 15.3284 7.00897 15.527 6.47827 15.2774C6.42242 15.2521 6.36841 15.2206 6.31653 15.184C6.20789 15.1074 6.0968 15.014 5.98877 14.9139C5.92865 14.8578 5.86884 14.7995 5.80994 14.7409C5.62622 14.5532 5.46051 14.361 5.34271 14.2178C5.28076 14.1412 5.23163 14.0799 5.20081 14.0393C5.17609 14.0079 5.16144 13.9896 5.16144 13.9896C5.09949 13.9087 5.0412 13.8269 4.98749 13.7451C4.92188 13.645 4.86237 13.5443 4.80896 13.4445C4.72382 13.2855 4.65363 13.1287 4.59534 12.9797C4.57245 12.9181 4.55048 12.8592 4.53064 12.8012C4.35272 12.2787 4.32465 11.8866 4.32465 11.8866C4.32983 11.8259 4.34479 11.778 4.36768 11.7413C4.47235 11.5695 4.729 11.6388 4.729 11.6388C4.81415 11.7023 4.90112 11.7572 4.98749 11.8036C5.31281 11.9815 5.63141 12.0526 5.80994 12.0807C5.90363 12.0956 5.95917 12.0984 5.95917 12.0984C5.96893 12.0984 5.97961 12.0984 5.98877 12.0978C6.34003 12.0905 6.61224 12.0319 6.81183 11.9623C6.87927 11.9397 6.93878 11.9153 6.99005 11.8912C7.15881 11.814 7.23938 11.7435 7.23938 11.7435C7.2406 11.7429 7.24243 11.7422 7.24396 11.7413C7.33948 11.6959 7.43103 11.6342 7.51678 11.5631C7.62482 11.4746 7.7243 11.3702 7.81311 11.2637C7.87872 11.1853 7.93823 11.106 7.99194 11.0297C8.06244 10.929 8.12195 10.8328 8.16772 10.755C8.10242 10.6784 8.04413 10.5954 7.99194 10.5084C7.91779 10.3851 7.85767 10.2524 7.81311 10.1117C7.80457 10.0842 7.79602 10.0562 7.789 10.0281C7.5238 10.1379 7.15546 10.2457 6.99005 10.2921C6.93634 10.3064 6.90369 10.3156 6.90369 10.3156C6.90369 10.3156 5.72235 10.4849 4.80896 10.3C4.53979 10.2457 4.29443 10.1608 4.10919 10.0314C4.06616 10.0006 4.02496 9.9704 3.98621 9.93988C3.92151 9.88892 3.862 9.83643 3.80768 9.78485C3.6203 9.60571 3.49426 9.42474 3.40851 9.26514C3.37372 9.20166 3.34625 9.14215 3.32336 9.08722C3.2428 8.88794 3.23029 8.75336 3.23029 8.75336C3.18726 8.51471 3.23883 8.24524 3.30627 8.02765C3.32672 7.96295 3.34747 7.90283 3.36792 7.84912C3.42682 7.69684 3.47961 7.59613 3.47961 7.59613C3.47961 7.59613 3.59039 7.36603 3.80768 7.04254C3.86047 6.9635 3.91998 6.87897 3.98621 6.79199C3.98621 6.79077 3.98682 6.79016 3.98743 6.78955C4.03076 6.73126 4.07715 6.67175 4.12628 6.61102C4.22058 6.49414 4.32526 6.3736 4.44092 6.25336C4.56482 6.12457 4.68903 6.00952 4.80896 5.90881C4.86969 5.85785 4.92981 5.81024 4.98749 5.7663C5.09796 5.68207 5.20264 5.61005 5.29572 5.55145C5.42389 5.46967 5.53131 5.41077 5.60455 5.37354C5.67535 5.33691 5.71503 5.31982 5.71503 5.31982C5.75043 5.32715 5.78247 5.33569 5.80994 5.34607C5.98267 5.40283 6.04156 5.4892 6.06079 5.55145C6.07452 5.5957 6.06842 5.62775 6.06842 5.62775C6.02936 5.72449 6.00372 5.82977 5.98877 5.93567V6.49414C5.99396 6.53442 5.99915 6.57379 6.00433 6.61102C6.0141 6.6745 6.02539 6.73462 6.03638 6.78955C6.07758 6.98578 6.12274 7.11639 6.12274 7.11639C6.21918 7.41699 6.39191 7.65778 6.5979 7.84912C6.71967 7.96234 6.85303 8.05847 6.99005 8.14026C7.27448 8.30933 7.57355 8.41736 7.81311 8.48328C7.8772 8.50098 7.93762 8.51593 7.99194 8.52844C8.00629 8.53088 8.02002 8.53424 8.03314 8.53699C8.16467 8.33618 8.33405 8.16376 8.5318 8.02765C8.55011 8.01453 8.56903 8.00232 8.58734 7.99042C8.55469 7.94983 8.51654 7.90283 8.47534 7.84912C8.33527 7.66693 8.15674 7.41241 7.99194 7.11182C7.90619 6.95618 7.8244 6.78833 7.7536 6.61102C7.71576 6.51886 7.68219 6.42334 7.65167 6.32599C7.59735 6.03973 7.55157 5.78735 7.52533 5.55145C7.51801 5.49133 7.51282 5.43182 7.50885 5.37354C7.48413 5.01526 7.51282 4.68506 7.63458 4.31335C7.6535 4.25507 7.67456 4.19556 7.69867 4.13544C7.73193 4.04968 7.77008 3.9621 7.81311 3.87054C7.8302 3.83667 7.84729 3.80127 7.8656 3.76465C7.8656 3.76465 7.9068 3.71368 7.99194 3.64502C8.13568 3.52875 8.40607 3.36151 8.815 3.30963C8.87207 3.30261 8.93097 3.29742 8.99323 3.29529C9.09241 3.29285 9.19861 3.29529 9.31061 3.30719C9.31061 3.30719 9.50745 3.32489 9.81628 3.39142C9.87183 3.40393 9.93225 3.41766 9.9942 3.43262C10.2332 3.49152 10.5167 3.57574 10.8176 3.69598C10.8765 3.71948 10.936 3.74451 10.9955 3.77075C11.2219 3.87054 11.4551 3.99017 11.6833 4.13544C11.7892 4.20135 11.8939 4.2746 11.9974 4.35303C12.0126 4.36432 12.0276 4.37592 12.0425 4.38782C12.0425 4.38782 12.2964 4.57458 12.3474 4.7818C12.3474 4.7818 12.3993 4.97925 12.1539 5.04608C12.1539 5.04608 12.0944 5.04333 11.9974 5.04944C11.947 5.05188 11.8863 5.05707 11.8188 5.06561C11.5878 5.09705 11.2723 5.17365 10.9955 5.35858C10.9149 5.41351 10.8371 5.47668 10.7666 5.55145C10.7581 5.56 10.7501 5.56824 10.7416 5.57739C10.7416 5.57739 10.3162 5.85327 10.0998 6.61102C10.0827 6.66779 10.0684 6.72668 10.0546 6.78955C10.029 6.90521 10.0079 7.03064 9.9942 7.16736V7.74384C10.1074 7.76947 10.2161 7.80487 10.3195 7.84912C10.4333 7.89764 10.5414 7.95776 10.6421 8.02765C10.6808 8.05328 10.7175 8.08136 10.7535 8.11066C10.7712 8.08533 10.7901 8.05786 10.8118 8.02765C10.8627 7.95502 10.9241 7.87201 10.9955 7.78046C11.1984 7.52289 11.4786 7.20459 11.8188 6.91895C11.9498 6.80969 12.0889 6.70532 12.2363 6.61102C12.2998 6.56982 12.3657 6.53137 12.4326 6.49475C12.4326 6.49475 12.5772 6.39984 12.8207 6.3031C12.8757 6.28082 12.9352 6.25946 12.9987 6.23779C13.2257 6.16333 13.5071 6.09985 13.822 6.09344C13.8803 6.09253 13.9404 6.09344 13.9999 6.0965C14.144 6.10321 14.2917 6.12335 14.4443 6.15936C14.4443 6.15936 14.617 6.20117 14.8233 6.3562C14.8813 6.39923 14.9417 6.45142 15.0018 6.51367C15.0305 6.54358 15.0595 6.57654 15.0882 6.61102C15.1315 6.66473 15.1733 6.72363 15.2139 6.78955C15.3055 6.93848 15.386 7.12097 15.4422 7.34467C15.4422 7.34467 15.4959 7.53601 15.5338 7.84912C15.5405 7.90527 15.5463 7.96417 15.5521 8.02765C15.5765 8.32001 15.5823 8.68591 15.528 9.08722C15.52 9.14551 15.5109 9.20563 15.4999 9.26514C15.4846 9.35669 15.4651 9.44946 15.4422 9.54285C15.3546 9.8999 15.2826 10.1505 15.2249 10.3256C15.2014 10.3961 15.1804 10.455 15.1614 10.5038C15.0732 10.7315 15.0327 10.7385 15.0327 10.7385C15.0327 10.7385 15.0214 10.7446 15.0018 10.751C14.9646 10.7654 14.8965 10.7843 14.8233 10.7761ZM14.8233 15.2774H13.9999V15.2762C14.2441 15.0879 14.4769 14.8831 14.6982 14.6616C14.7406 14.6191 14.7827 14.5773 14.8233 14.5334V15.2774ZM14.8233 16.5155H13.9999V15.4559H14.8233V16.5155ZM14.8233 18.1015H13.9999V16.694H14.8233V18.1015ZM13.822 16.5155H12.9987V15.9253C13.2605 15.7855 13.5144 15.6287 13.7579 15.4559H13.822V16.5155ZM13.822 18.1015H12.9987V16.694H13.822V18.1015ZM12.8207 16.5155H11.9974V16.3672C12.2787 16.2686 12.5537 16.1514 12.8207 16.0181V16.5155ZM12.8207 18.1015H11.9974V16.694H12.8207V18.1015ZM11.8188 16.5155H11.525C11.6238 16.488 11.7212 16.4587 11.8188 16.4279V16.5155ZM11.8188 18.1015H10.9955V16.694H11.8188V18.1015ZM10.8176 18.1015H9.9942V16.7654C10.2286 16.7529 10.4608 16.7288 10.69 16.694H10.8176V18.1015ZM9.81628 18.1015H8.99323V16.7529C9.19006 16.7694 9.38782 16.777 9.5874 16.777C9.66309 16.777 9.7403 16.7752 9.81628 16.7731V18.1015ZM8.815 18.1015H7.99194V16.694H8.48389C8.59375 16.7105 8.70392 16.7249 8.815 16.7365V18.1015ZM6.99005 16.5155V16.2991C7.20581 16.3815 7.42584 16.4542 7.64893 16.5155H6.99005ZM7.81311 18.1015H6.99005V16.694H7.81311V18.1015ZM6.81183 16.5155H5.98877V15.8221C6.25519 15.975 6.52924 16.1108 6.81183 16.228V16.5155ZM6.81183 18.1015H5.98877V16.694H6.81183V18.1015ZM4.98749 15.2774V15.1279C5.04974 15.1788 5.11261 15.2286 5.17609 15.2774H4.98749ZM5.80994 16.5155H4.98749V15.4559H5.41534C5.54504 15.5469 5.67657 15.6339 5.80994 15.7162V16.5155ZM5.80994 18.1015H4.98749V16.694H5.80994V18.1015ZM4.80896 15.2774H3.98621V14.2178H4.06616C4.19556 14.3707 4.33228 14.519 4.4751 14.6616C4.58374 14.7702 4.69482 14.8749 4.80896 14.9747V15.2774ZM4.80896 16.5155H3.98621V15.4559H4.80896V16.5155ZM4.80896 18.1015H3.98621V16.694H4.80896V18.1015ZM3.80768 14.0393H2.98431V12.9797H3.2193C3.39081 13.298 3.58765 13.6038 3.80768 13.8956V14.0393ZM3.80768 15.2774H2.98431V14.2178H3.80768V15.2774ZM3.80768 16.5155H2.98431V15.4559H3.80768V16.5155ZM3.80768 18.1015H2.98431V16.694H3.80768V18.1015ZM2.8064 2.89734H1.98303V1.6217H2.8064V2.89734ZM2.8064 4.13544H1.98303V3.07556H2.8064V4.13544ZM2.8064 5.37354H1.98303V4.31335H2.8064V5.37354ZM2.8064 6.61102H1.98303V5.55145H2.8064V6.61102ZM2.8064 7.04132C2.70874 7.3053 2.62634 7.57538 2.56042 7.84912H1.98303V6.78955H2.8064V7.04132ZM2.8064 12.8012H1.98303V11.7413H2.69379C2.72858 11.8518 2.76642 11.9611 2.8064 12.0703V12.8012ZM2.8064 14.0393H1.98303V12.9797H2.8064V14.0393ZM2.8064 15.2774H1.98303V14.2178H2.8064V15.2774ZM2.8064 16.5155H1.98303V15.4559H2.8064V16.5155ZM2.8064 18.1015H1.98303V16.694H2.8064V18.1015ZM1.80511 2.89734H0.858765V1.94794C0.858765 1.76758 1.00555 1.6217 1.1853 1.6217H1.80511V2.89734ZM1.80511 4.13544H0.858765V3.07556H1.80511V4.13544ZM1.80511 5.37354H0.858765V4.31335H1.80511V5.37354ZM1.80511 6.61102H0.858765V5.55145H1.80511V6.61102ZM1.80511 7.84912H0.858765V6.78955H1.80511V7.84912ZM1.80511 9.08722H0.858765V8.02765H1.80511V9.08722ZM1.80511 10.3256H0.858765V9.26514H1.80511V10.3256ZM1.80511 11.5631H0.858765V10.5038H1.80511V11.5631ZM1.80511 12.8012H0.858765V11.7413H1.80511V12.8012ZM1.80511 14.0393H0.858765V12.9797H1.80511V14.0393ZM1.80511 15.2774H0.858765V14.2178H1.80511V15.2774ZM1.80511 16.5155H0.858765V15.4559H1.80511V16.5155ZM1.80511 18.1015H1.1853C1.00555 18.1015 0.858765 17.9556 0.858765 17.7753V16.694H1.80511V18.1015ZM1.98303 10.5038H2.41943C2.46674 10.8643 2.53998 11.218 2.63947 11.5631H1.98303V10.5038ZM1.98303 9.26514H2.36328C2.35992 9.36127 2.35809 9.45862 2.35809 9.55597C2.35809 9.81415 2.37183 10.0717 2.39868 10.3256H1.98303V9.26514ZM1.98303 8.02765H2.51984C2.44507 8.37402 2.39594 8.72772 2.37305 9.08722H1.98303V8.02765ZM2.98431 12.5049C3.02887 12.605 3.07587 12.7039 3.12561 12.8012H2.98431V12.5049ZM2.98431 5.55145H3.56934C3.34412 5.88745 3.1485 6.23962 2.98431 6.60583V5.55145ZM2.98431 4.31335H3.80768V5.21545C3.76831 5.26825 3.72955 5.32074 3.69232 5.37354H2.98431V4.31335ZM2.98431 3.07556H3.80768V4.13544H2.98431V3.07556ZM2.98431 1.6217H3.80768V2.89734H2.98431V1.6217ZM3.98621 4.31335H4.61578C4.56879 4.3576 4.52209 4.40338 4.4751 4.44977C4.30237 4.6225 4.13879 4.80286 3.98621 4.98993V4.31335ZM3.98621 3.07556H4.80896V4.13544H3.98621V3.07556ZM3.98621 1.6217H4.80896V2.89734H3.98621V1.6217ZM4.98749 3.07556H5.80994V3.39478C5.5246 3.57056 5.24933 3.76801 4.98749 3.98438V3.07556ZM4.98749 1.6217H5.80994V2.89734H4.98749V1.6217ZM5.98877 3.07556H6.38977C6.25427 3.1424 6.1203 3.2135 5.98877 3.28949V3.07556ZM5.98877 1.6217H6.81183V2.88422C6.80084 2.88818 6.79047 2.89276 6.77979 2.89734H5.98877V1.6217ZM6.99005 1.6217H7.81311V2.55219C7.53387 2.62268 7.25891 2.70905 6.99005 2.81219V1.6217ZM7.99194 1.6217H8.815V2.37488C8.53699 2.40448 8.26202 2.44934 7.99194 2.51038V1.6217ZM8.99323 1.6217H9.81628V2.33826C9.7403 2.33582 9.66309 2.33429 9.5874 2.33429C9.38782 2.33429 9.19006 2.34222 8.99323 2.3587V1.6217ZM9.9942 1.6217H10.8176V2.43774C10.5472 2.39197 10.2719 2.36115 9.9942 2.34558V1.6217ZM10.9955 1.6217H11.8188V2.68341C11.5497 2.59644 11.275 2.52594 10.9955 2.4704V1.6217ZM12.8207 3.07556V3.09326C12.8088 3.08685 12.7963 3.08105 12.7841 3.07556H12.8207ZM11.9974 1.6217H12.8207V2.89734H12.3941C12.2638 2.84241 12.131 2.79083 11.9974 2.74414V1.6217ZM12.9987 3.07556H13.822V3.70209C13.5583 3.51044 13.284 3.33862 12.9987 3.18604V3.07556ZM12.9987 1.6217H13.822V2.89734H12.9987V1.6217ZM14.8233 4.31335V4.57733C14.7827 4.53491 14.7406 4.49158 14.6982 4.44977C14.6524 4.40338 14.6051 4.3576 14.5581 4.31335H14.8233ZM13.9999 3.07556H14.8233V4.13544H14.3637C14.2453 4.03137 14.1241 3.93158 13.9999 3.83545V3.07556ZM13.9999 1.6217H14.8233V2.89734H13.9999V1.6217ZM23.6465 0.627441H0.377197C0.171814 0.627441 0.00366211 0.795593 0.00366211 1.00067V18.9984C0.00366211 19.2044 0.171814 19.371 0.377197 19.371H23.6465C23.8525 19.371 24.0201 19.2044 24.0201 18.9984V1.00067C24.0201 0.795593 23.8525 0.627441 23.6465 0.627441Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M23.1653 1.77429H18.8535C18.7946 1.77429 18.7461 1.82251 18.7461 1.88141V17.8415C18.7461 17.901 18.7946 17.9492 18.8535 17.9492H23.1653C23.2249 17.9492 23.2734 17.901 23.2734 17.8415V1.88141C23.2734 1.82251 23.2249 1.77429 23.1653 1.77429Z"
      fill="#758BFD"
    />
    <path
      d="M10.4973 9.3219C10.4842 9.27246 10.468 9.22455 10.4476 9.17816C10.3868 9.03961 10.2932 8.91876 10.1769 8.82446C10.0988 8.7619 10.0106 8.71155 9.91504 8.67554C9.87323 8.65967 9.82928 8.64746 9.78473 8.6377C9.78015 8.63709 9.77557 8.63617 9.77161 8.63495C9.7121 8.62335 9.64984 8.61664 9.58728 8.61664C9.41241 8.61664 9.24884 8.66425 9.10876 8.74756C9.09961 8.75275 9.09045 8.75854 9.0813 8.76373C9.0401 8.79059 9.00134 8.81989 8.96472 8.85193C8.90186 8.90686 8.84692 8.97034 8.80115 9.04083C8.77246 9.08417 8.74744 9.13055 8.72607 9.17816C8.70563 9.22394 8.68945 9.27246 8.67694 9.3219C8.6571 9.39667 8.64673 9.4751 8.64673 9.55597C8.64673 9.63837 8.65802 9.71832 8.67755 9.79401C8.71356 9.93195 8.7804 10.0568 8.8692 10.162C8.87317 10.1666 8.87714 10.1712 8.8811 10.1758C8.94641 10.2496 9.02301 10.3137 9.10876 10.3641C9.23297 10.4373 9.37579 10.4831 9.52747 10.4929C9.5473 10.4941 9.56683 10.4947 9.58728 10.4947C9.64984 10.4947 9.7121 10.4883 9.77161 10.4764C9.82074 10.4666 9.86926 10.4529 9.91504 10.4352C9.93335 10.4288 9.95166 10.4218 9.96936 10.4138C10.0276 10.3876 10.0826 10.3555 10.1335 10.3189C10.1918 10.2777 10.2455 10.2295 10.2925 10.1758C10.3652 10.0934 10.4235 9.99878 10.4634 9.8941C10.5046 9.78943 10.5269 9.67499 10.5269 9.55597C10.5269 9.52209 10.5248 9.48944 10.5217 9.4574C10.5165 9.41101 10.5086 9.36584 10.4973 9.3219Z"
      fill="#758BFD"
    />
  </svg>
);

export const LAEP_SSEN_FUNDING_ICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_449_471"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="-1"
      width="24"
      height="26"
    >
      <path
        d="M0.28125 -0.00012207H23.6406V24.0233H0.28125V-0.00012207Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_449_471)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.11179 16.9234C2.15054 17.1846 1.97019 17.4272 1.71048 17.4654C1.44834 17.5038 1.20786 17.3229 1.1694 17.0616C1.13095 16.8007 1.31131 16.5575 1.57102 16.5194C1.83316 16.4815 2.07578 16.6622 2.11179 16.9234ZM15.1022 6.7229C16.43 8.19934 17.4212 9.48139 18.0749 10.6316C19.3149 12.813 19.0078 15.0118 17.7923 16.621L16.7083 17.2536C16.4169 17.4239 16.1197 17.5316 15.8127 17.5844C15.9408 17.4138 16.0397 17.2097 16.1035 16.9728C16.3446 16.0775 15.8099 15.1921 14.9511 14.894L14.8956 14.8748L14.8376 14.8641C14.6393 14.8278 14.4421 14.7866 14.2459 14.7414C14.4211 14.5064 14.5239 14.2174 14.5157 13.8689C14.5141 13.8091 14.5108 13.7563 14.5053 13.7111C14.4357 13.1374 14.1259 12.7639 13.7152 12.5154C13.3545 12.2972 12.9217 12.1886 12.525 12.1233C12.239 12.0763 11.9375 11.9966 11.7169 11.8523C11.546 11.7403 11.4233 11.5786 11.4117 11.3417C11.3992 11.0854 11.5109 10.8788 11.687 10.7354C11.8246 10.623 12.0004 10.5452 12.1911 10.5068C12.2677 10.4912 12.3468 10.4824 12.4264 10.4802C12.4347 10.4808 12.4432 10.4811 12.4518 10.4811C12.4621 10.4811 12.4725 10.4805 12.4826 10.4799C12.5879 10.4814 12.6941 10.4952 12.7975 10.5214C13.1161 10.6023 13.4063 10.8126 13.5592 11.1772C13.6508 11.3961 13.9019 11.4989 14.1201 11.407C14.3384 11.3155 14.4409 11.0637 14.3493 10.8449C14.0805 10.2031 13.5684 9.83234 13.0053 9.68921C12.9638 9.67883 12.9223 9.66937 12.8805 9.66144V9.3288C12.8805 9.09168 12.6886 8.89942 12.4518 8.89942C12.2149 8.89942 12.0233 9.09168 12.0233 9.3288V9.66785C11.6983 9.73346 11.3934 9.87079 11.1477 10.071C10.7702 10.3786 10.5307 10.8251 10.5578 11.382C10.585 11.9414 10.8636 12.3165 11.2515 12.5704C11.5896 12.7913 12.0047 12.9058 12.3877 12.9689C12.6953 13.0193 13.0237 13.0995 13.2733 13.2503C13.4729 13.3712 13.6227 13.5475 13.6548 13.8118C13.659 13.8469 13.6612 13.8726 13.6618 13.889C13.6667 14.0993 13.5663 14.2592 13.4155 14.374C13.3645 14.4127 13.3078 14.4475 13.2467 14.4777C12.1396 14.1515 11.1111 13.7285 10.0177 13.373C8.87631 13.0019 7.81247 13.4218 6.82614 13.9943L6.15476 14.3843C5.94083 13.21 6.13339 11.9179 6.8646 10.6316C7.51859 9.48169 8.50949 8.19934 9.83731 6.72321C10.0039 6.77753 10.1816 6.80713 10.3659 6.80713H14.5736C14.758 6.80713 14.9356 6.77753 15.1022 6.7229ZM10.3659 6.03534H14.5736C15.0924 6.03534 15.5169 5.61023 15.5169 5.09052C15.5169 4.5708 15.0924 4.14539 14.5736 4.14539H10.3659C9.84708 4.14539 9.42258 4.5708 9.42258 5.09052C9.42258 5.61023 9.84708 6.03534 10.3659 6.03534ZM10.3314 3.37451L9.55686 2.59814C9.17996 2.22064 9.17996 1.60266 9.55686 1.22485C9.8776 0.903809 10.3848 0.849487 10.7666 1.09485C10.9082 1.18579 11.0708 1.20044 11.2265 1.13574C11.3821 1.07135 11.4868 0.945923 11.5228 0.780823C11.6177 0.345032 12.0071 0.0160523 12.4698 0.0157471C12.9242 0.0157471 13.3203 0.336792 13.417 0.780823C13.453 0.945923 13.5577 1.07135 13.7134 1.13574C13.8687 1.20044 14.0313 1.18579 14.1733 1.09485C14.548 0.85376 15.0555 0.897095 15.3827 1.22485C15.7596 1.60266 15.7596 2.22064 15.3827 2.59814L14.6081 3.37451C14.5965 3.37421 14.5852 3.3739 14.5736 3.3739H10.3659C10.3543 3.3739 10.343 3.37421 10.3314 3.37451ZM3.64926 16.7299L6.21762 21.2715L7.18411 20.7125C7.2778 20.6581 7.38858 20.6438 7.49448 20.6719L13.5641 22.0113C14.367 22.2264 15.122 22.1202 15.812 21.6951L23.183 17.1056C23.5843 16.859 23.7069 16.1348 23.4305 15.671C23.0291 14.9996 21.9665 15.0786 20.5862 15.8834L17.0959 17.9204C16.3699 18.3452 15.5862 18.4829 14.7036 18.3412C14.5428 18.315 14.3841 18.2872 14.2279 18.2573C14.194 18.2549 11.2585 17.4904 10.9219 17.3995C10.7031 17.3412 10.5734 17.1172 10.6335 16.8996C10.6912 16.6814 10.9149 16.5523 11.1313 16.6106C11.4749 16.7028 13.5571 17.2942 14.3384 17.4465C14.7375 17.4721 15.2014 17.3607 15.3601 16.772C15.4901 16.2892 15.2063 15.7991 14.6991 15.623C13.2733 15.3615 11.8957 14.8629 10.7898 14.4615C10.4025 14.3218 10.0683 14.2006 9.77994 14.1069C8.87113 13.8115 8.00809 14.1991 7.21219 14.6617L3.64926 16.7299ZM6.12454 22.7721L2.19602 15.8171C2.15756 15.7491 2.095 15.7006 2.0181 15.6789C1.99185 15.6722 1.9653 15.6685 1.93875 15.6685C1.8884 15.6685 1.84018 15.6813 1.79685 15.7058L0.460176 16.4635C0.318269 16.5435 0.270357 16.7235 0.349703 16.8645L4.27823 23.8195C4.35758 23.9611 4.53794 24.0105 4.6771 23.9308L6.01407 23.1731C6.08121 23.1346 6.12943 23.0715 6.15109 22.9955C6.17276 22.9195 6.163 22.8402 6.12454 22.7721Z"
        fill="#758BFD"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_FLEXIBILITY_ICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_452_667"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="28"
      y="25"
      width="13"
      height="18"
    >
      <path d="M28.8281 25.7031H40.463V42.0233H28.8281V25.7031Z" fill="white" />
    </mask>
    <g mask="url(#mask0_452_667)">
      <path
        d="M40.3809 29.8102L36.5128 25.8249C36.3757 25.6839 36.1371 25.7809 36.1371 25.9775V28.6377C35.1559 28.638 34.2035 28.8309 33.306 29.2108C32.4384 29.5779 31.6599 30.1031 30.9912 30.7721C30.3229 31.4407 29.798 32.2201 29.4312 33.0881C29.0509 33.9871 28.858 34.9417 28.858 35.925V42.0184H31.5182V35.925C31.5182 33.3759 33.5898 31.3016 36.1371 31.2991V33.9481C36.1371 34.1446 36.3757 34.2416 36.5128 34.1003L40.3809 30.115C40.4636 30.0302 40.4636 29.895 40.3809 29.8102Z"
        fill="#758BFD"
      />
      <path
        d="M40.3809 29.8102L36.5128 25.8249C36.3757 25.6839 36.1371 25.7809 36.1371 25.9775V28.6377C35.1559 28.638 34.2035 28.8309 33.306 29.2108C32.4384 29.5779 31.6599 30.1031 30.9912 30.7721C30.3229 31.4407 29.798 32.2201 29.4312 33.0881C29.0509 33.9871 28.858 34.9417 28.858 35.925V42.0184H31.5182V35.925C31.5182 33.3759 33.5898 31.3016 36.1371 31.2991V33.9481C36.1371 34.1446 36.3757 34.2416 36.5128 34.1003L40.3809 30.115C40.4636 30.0302 40.4636 29.895 40.3809 29.8102Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask1_452_667"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="19"
      y="25"
      width="11"
      height="10"
    >
      <path
        d="M19.5449 25.7031H29.4531V34.2188H19.5449V25.7031Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_452_667)">
      <path
        d="M28.5644 32.7212C28.7926 32.1811 29.0755 31.6714 29.4094 31.1963C29.2846 31.0504 29.154 30.9088 29.0172 30.7718C28.3486 30.1031 27.5701 29.5779 26.7025 29.2105C25.8053 28.8309 24.8525 28.638 23.8717 28.6374V25.9772C23.8717 25.7806 23.6327 25.6836 23.4957 25.8246L19.6276 29.8099C19.5452 29.895 19.5452 30.0299 19.6276 30.115L23.4957 34.1003C23.6327 34.2413 23.8717 34.1443 23.8717 33.9477V31.2991C25.7744 31.3007 27.4117 32.4588 28.1185 34.1074C28.225 33.6349 28.3739 33.172 28.5644 32.7212Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask2_452_667"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="25"
      y="17"
      width="10"
      height="14"
    >
      <path
        d="M25.9375 17.9999H34.4531V30.7031H25.9375V17.9999Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_452_667)">
      <path
        d="M34.3277 21.9583L30.3449 18.0878C30.26 18.0054 30.1248 18.0054 30.04 18.0878L26.0572 21.9583C25.9162 22.0953 26.0132 22.3343 26.2097 22.3343H28.8755V29.7018C29.097 29.8807 29.3097 30.0723 29.5133 30.2759C29.6268 30.3894 29.7385 30.5081 29.8459 30.6296C29.9979 30.4489 30.1578 30.2747 30.326 30.1062C30.6723 29.7598 31.0449 29.4476 31.4414 29.1711V22.3343H34.1754C34.372 22.3343 34.4687 22.0953 34.3277 21.9583Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask3_452_667"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="19"
      y="25"
      width="11"
      height="10"
    >
      <path
        d="M19.5449 25.7031H29.4531V34.2188H19.5449V25.7031Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_452_667)">
      <path
        d="M28.5644 32.7212C28.7926 32.1811 29.0755 31.6714 29.4094 31.1963C29.2846 31.0504 29.154 30.9088 29.0172 30.7718C28.3486 30.1031 27.5701 29.5779 26.7025 29.2105C25.8053 28.8309 24.8525 28.638 23.8717 28.6374V25.9772C23.8717 25.7806 23.6327 25.6836 23.4957 25.8246L19.6276 29.8099C19.5452 29.895 19.5452 30.0299 19.6276 30.115L23.4957 34.1003C23.6327 34.2413 23.8717 34.1443 23.8717 33.9477V31.2991C25.7744 31.3007 27.4117 32.4588 28.1185 34.1074C28.225 33.6349 28.3739 33.172 28.5644 32.7212Z"
        fill="#758BFD"
      />
    </g>
  </svg>
);

export const LAEP_SSEN_LOWCARBON_ICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_712_63"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="22"
    >
      <path d="M0 0.699377H23.9994V21.33H0V0.699377Z" fill="white" />
    </mask>
    <g mask="url(#mask0_712_63)">
      <path
        d="M15.9863 11.455C16.0169 11.3888 16.0494 11.3369 16.085 11.2994C16.2269 11.1513 16.5831 10.7938 16.7394 10.6888C17.6819 10.0213 16.77 9.39438 16.43 9.91625C16.3881 9.97875 16.3675 10.125 16.2856 10.225C16.1981 10.3319 15.9481 10.3063 15.9481 10.08C15.9481 9.73375 16.2488 9.38563 16.7825 9.38563C16.9525 9.38563 17.0975 9.4125 17.2175 9.46625C17.4644 9.57938 17.6088 9.82875 17.6088 10.0831C17.6088 10.7281 16.8338 10.9669 16.5144 11.4525C17.33 11.4669 17.4688 11.4175 17.5825 11.5063C17.7013 11.5994 17.675 11.8463 17.4325 11.8463C16.2475 11.8263 16.1319 11.8963 16.0113 11.7769C15.9119 11.6788 15.9331 11.5731 15.9863 11.455ZM13.1406 10.6919C11.7769 10.6919 10.9613 9.80063 10.9613 8.37875C10.9613 7.0325 11.7181 6.09 13.1225 6.09C13.9694 6.09 14.6925 6.42313 15.0594 7.16875C15.5963 8.26 15.45 10.6919 13.1406 10.6919ZM8.53938 10.6919C7.68313 10.6919 7.03625 10.3944 6.64438 9.57625C6.32063 8.9 6.33688 8.02 6.55188 7.43438C7.17125 5.74875 9.36125 5.76313 10.1213 6.83813C10.5469 7.43938 10.2844 7.82938 9.97313 7.82938C9.8575 7.82938 9.77125 7.80188 9.71375 7.7475C9.47438 7.52 9.36063 6.80625 8.52125 6.80625C7.66313 6.80625 7.30813 7.55875 7.30813 8.4275C7.30813 9.29125 7.64188 9.97563 8.49063 9.97563C9.0175 9.97563 9.37313 9.70625 9.55188 9.21688C9.59 9.09938 9.6375 9.00375 9.69438 8.93C9.86875 8.70125 10.3581 8.82313 10.3581 9.21063C10.3581 9.77563 9.79 10.6919 8.53938 10.6919ZM23.7694 8.255C22.9038 5.92813 19.7613 6.09 19.7613 6.09C19.7613 6.09 18.3838 1.70188 13.8538 3.83813C13.8538 3.83813 12.7475 0.699377 9.27125 0.699377C5.79438 0.699377 5.13625 3.7625 5.13625 3.7625C5.13625 3.7625 0 4.02313 0 9.16688C0 11.9831 1.76063 13.2094 3.60813 13.4881C3.79063 13.5156 3.97563 13.5275 4.16 13.5275H6.34563V17.0825L5.305 16.6519C5.2125 16.6138 5.10438 16.6806 5.145 16.7513L7.06313 20.0975L8.98125 16.7513C9.02125 16.6806 8.91375 16.6138 8.82125 16.6519L7.78125 17.0825V13.5275H11.2819V18.315L10.2413 17.8844C10.1488 17.8456 10.0413 17.9125 10.0813 17.9831L12 21.33L13.9175 17.9831C13.9581 17.9125 13.85 17.8456 13.7575 17.8844L12.7175 18.315V13.5275H16.2188V17.0825L15.1781 16.6519C15.0856 16.6138 14.9775 16.6806 15.0181 16.7513L16.9363 20.0975L18.8538 16.7513C18.8944 16.6806 18.7863 16.6138 18.6944 16.6519L17.6538 17.0825V13.5275H20.0556C20.8306 13.5275 21.5931 13.3019 22.2313 12.8613C22.7438 12.5075 23.2138 12.0056 23.5706 11.3044C24.0538 10.3569 24.1406 9.25125 23.7694 8.255Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M12.23 7.20375C11.7007 7.82625 11.6907 9.455 12.6388 9.87563C13.2807 10.16 14.4019 9.90813 14.4019 8.37875C14.4019 6.615 12.825 6.50438 12.23 7.20375Z"
      fill="#758BFD"
    />
  </svg>
);

export const LAEP_SSEN_CONNECTIONS_ICON = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "60px", height: "60px" }}
  >
    <mask
      id="mask0_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="28"
      y="25"
      width="25"
      height="10"
    >
      <path
        d="M28.9844 25.5469H52.6514V34.5313H28.9844V25.5469Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_452_666)">
      <path
        d="M37.4836 30.1382L37.4473 30.9503L35.2347 30.1184L37.0014 30.191L37.0392 29.3762L39.2472 30.2109L37.4836 30.1382ZM52.6514 28.5693C52.3539 29.1034 51.7841 29.4656 51.131 29.4656H42.2681V29.1132H40.2695V28.0405C40.2695 27.3108 39.6784 26.7191 38.949 26.7191H35.1374V26.499C35.1374 25.9927 34.7275 25.5823 34.2219 25.5823C33.7162 25.5823 33.306 25.9927 33.306 26.499V27.6584H29.4715C29.2304 27.6584 29.0354 27.8534 29.0354 28.0945C29.0354 28.3353 29.2304 28.5306 29.4715 28.5306H33.306V31.528H29.4861C29.2542 31.528 29.0513 31.7038 29.0366 31.9354C29.0198 32.1893 29.2209 32.4002 29.4715 32.4002H33.306V33.5602C33.306 34.0662 33.7162 34.4766 34.2219 34.4766C34.7275 34.4766 35.1374 34.0662 35.1374 33.5602V33.3398H38.949C39.6784 33.3398 40.2695 32.7481 40.2695 32.0181V30.946H42.2681V30.5933H51.0871C51.6596 30.5933 52.1976 30.4276 52.6514 30.141V28.5693Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask1_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="25"
      width="20"
      height="10"
    >
      <path d="M7.3584 25.5469H26.7188V34.5313H7.3584V25.5469Z" fill="white" />
    </mask>
    <g mask="url(#mask1_452_666)">
      <path
        d="M23.7357 31.2924C23.7357 31.4151 23.6359 31.5149 23.5132 31.5149C23.3902 31.5149 23.2904 31.4151 23.2904 31.2924V28.7668C23.2904 28.6435 23.3902 28.5437 23.5132 28.5437C23.6359 28.5437 23.7357 28.6435 23.7357 28.7668V31.2924ZM22.8156 31.2924C22.8156 31.4151 22.7158 31.5149 22.5928 31.5149C22.4698 31.5149 22.37 31.4151 22.37 31.2924V28.7668C22.37 28.6435 22.4698 28.5437 22.5928 28.5437C22.7158 28.5437 22.8156 28.6435 22.8156 28.7668V31.2924ZM21.8951 31.2924C21.8951 31.4151 21.7953 31.5149 21.6724 31.5149C21.5494 31.5149 21.4496 31.4151 21.4496 31.2924V28.7668C21.4496 28.6435 21.5494 28.5437 21.6724 28.5437C21.7953 28.5437 21.8951 28.6435 21.8951 28.7668V31.2924ZM25.7883 25.5823C25.2826 25.5823 24.8724 25.9927 24.8724 26.499V26.7191H21.0611C20.3317 26.7191 19.7406 27.3108 19.7406 28.0405V29.1132H17.742V29.4656H8.92273C8.35022 29.4656 7.8125 29.631 7.3584 29.9176V31.4896C7.65594 30.9555 8.22571 30.5933 8.87909 30.5933H17.742V30.946H19.7406V32.0181C19.7406 32.7481 20.3317 33.3398 21.0611 33.3398H24.8724V33.5602C24.8724 34.0662 25.2826 34.4766 25.7883 34.4766C26.2936 34.4766 26.7038 34.0662 26.7038 33.5602V26.499C26.7038 25.9927 26.2936 25.5823 25.7883 25.5823Z"
        fill="#758BFD"
      />
    </g>
    <mask
      id="mask2_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="32"
      y="17"
      width="2"
      height="5"
    >
      <path d="M32.1094 17.9999H33.5156V21.875H32.1094V17.9999Z" fill="white" />
    </mask>
    <g mask="url(#mask2_452_666)">
      <path
        d="M32.4005 21.8274C32.3818 21.8274 32.3632 21.825 32.3446 21.8198C32.2299 21.7889 32.1615 21.6711 32.1923 21.5561L33.0908 18.2004C33.1216 18.0853 33.2397 18.0173 33.3544 18.0481C33.4692 18.0789 33.5375 18.1967 33.5067 18.3115L32.6083 21.6675C32.5823 21.7639 32.4954 21.8274 32.4005 21.8274Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M35.2835 23.7927C35.2286 23.7927 35.1733 23.7717 35.1315 23.7296C35.0473 23.6456 35.0473 23.5095 35.1315 23.425L37.5864 20.9686C37.67 20.8844 37.8064 20.8844 37.8906 20.9686C37.9749 21.0526 37.9749 21.1887 37.8906 21.2732L35.4355 23.7296C35.3937 23.7717 35.3384 23.7927 35.2835 23.7927Z"
      fill="#758BFD"
    />
    <mask
      id="mask3_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="26"
      y="17"
      width="2"
      height="5"
    >
      <path d="M26.4844 17.9999H27.8906V21.875H26.4844V17.9999Z" fill="white" />
    </mask>
    <g mask="url(#mask3_452_666)">
      <path
        d="M27.6092 21.8274C27.5146 21.8274 27.4276 21.7639 27.4017 21.6675L26.5032 18.3115C26.4724 18.1967 26.5408 18.0789 26.6552 18.0481C26.7703 18.0173 26.8881 18.0853 26.9189 18.2004L27.8173 21.5561C27.8482 21.6711 27.7798 21.7889 27.6654 21.8198C27.6464 21.825 27.6278 21.8274 27.6092 21.8274Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M24.7266 23.7927C24.6713 23.7927 24.6161 23.7717 24.5743 23.7296L22.1194 21.2732C22.0352 21.1887 22.0352 21.0526 22.1194 20.9686C22.2037 20.8844 22.3398 20.8844 22.4237 20.9686L24.8782 23.425C24.9625 23.5095 24.9625 23.6456 24.8782 23.7296C24.8367 23.7717 24.7815 23.7927 24.7266 23.7927Z"
      fill="#758BFD"
    />
    <mask
      id="mask4_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="26"
      y="38"
      width="2"
      height="5"
    >
      <path
        d="M26.4844 38.2031H27.8308V42.0181H26.4844V38.2031Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_452_666)">
      <path
        d="M27.6092 38.2312C27.6278 38.2312 27.6464 38.2339 27.6654 38.2388C27.7798 38.2697 27.8482 38.3875 27.8173 38.5025L26.9189 41.8582C26.8881 41.9733 26.77 42.0413 26.6552 42.0108C26.5408 41.98 26.4724 41.8619 26.5032 41.7471L27.4017 38.3911C27.4276 38.2947 27.5146 38.2312 27.6092 38.2312Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M24.7266 36.2659C24.7815 36.2659 24.8367 36.2869 24.8782 36.329C24.9625 36.4133 24.9625 36.5497 24.8782 36.6336L22.4237 39.0906C22.3398 39.1745 22.2037 39.1745 22.1194 39.0906C22.0352 39.006 22.0352 38.8699 22.1194 38.786L24.574 36.329C24.6161 36.2869 24.6713 36.2659 24.7266 36.2659Z"
      fill="#758BFD"
    />
    <mask
      id="mask5_452_666"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x="32"
      y="38"
      width="2"
      height="5"
    >
      <path d="M32.179 38.2031H33.5156V42.0181H32.179V38.2031Z" fill="white" />
    </mask>
    <g mask="url(#mask5_452_666)">
      <path
        d="M32.4005 38.2312C32.4954 38.2312 32.5823 38.2947 32.6083 38.3911L33.5067 41.7471C33.5375 41.8619 33.4692 41.98 33.3544 42.0108C33.2397 42.0413 33.1216 41.9733 33.0908 41.8582L32.1923 38.5025C32.1615 38.3875 32.2299 38.2697 32.3446 38.2388C32.3632 38.2339 32.3818 38.2312 32.4005 38.2312Z"
        fill="#758BFD"
      />
    </g>
    <path
      d="M35.2835 36.2659C35.3384 36.2659 35.3937 36.2869 35.4355 36.329L37.8906 38.786C37.9749 38.8699 37.9749 39.006 37.8906 39.0906C37.8064 39.1745 37.67 39.1745 37.5864 39.0906L35.1315 36.6336C35.0473 36.5497 35.0473 36.4133 35.1315 36.329C35.1733 36.2869 35.2286 36.2659 35.2835 36.2659Z"
      fill="#758BFD"
    />
  </svg>
);
